var _defs, _feBlend, _feBlend2, _feBlend3, _defs2, _feBlend4, _feBlend5, _feBlend6, _defs3, _feBlend7, _feBlend8, _feBlend9, _feBlend10, _feBlend11, _feBlend12, _feBlend13, _defs4, _feBlend14, _feBlend15, _feBlend16, _defs5, _feBlend17, _feBlend18, _feBlend19, _feBlend20, _feBlend21, _defs6, _feBlend22, _feBlend23, _feBlend24, _defs7, _feBlend25, _feBlend26, _feBlend27, _defs8, _feBlend28, _feBlend29, _feBlend30, _defs9, _feBlend31, _feBlend32, _feBlend33, _defs10, _feBlend34, _feBlend35, _feBlend36, _defs11, _feBlend37, _feBlend38, _feBlend39;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 998",
    style: {
      enableBackground: "new 0 0 1000 998"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 1000,
    height: 998
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 644.7595,
    y1: 334.3419,
    x2: 650.9008,
    y2: 641.3961
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2901,
    style: {
      stopColor: "#D6F0FA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7473,
    style: {
      stopColor: "#B6DBF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#AAD3F1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M850.071,683.654H448.469c-4.592,0-8.343-3.751-8.343-8.343V444.413 c0-4.591,3.751-8.343,8.343-8.343h40.682c2.911,0,4.819-3.045,3.559-5.677l-14.224-29.457c-0.531-1.097,0.676-2.211,1.721-1.587 l56.271,33.168c3.944,2.328,8.436,3.553,13.016,3.553h300.576c4.586,0,8.343,3.752,8.343,8.343v230.898 C858.414,679.902,854.657,683.654,850.071,683.654z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065766661595044532660000009839085449873697952_",
    gradientUnits: "userSpaceOnUse",
    x1: -411.6692,
    y1: 579.926,
    x2: -411.6692,
    y2: 456.1417,
    gradientTransform: "matrix(-1 0 0 1 236.583 7.9826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000065766661595044532660000009839085449873697952_)"
    },
    points: "444.484,676.04 852.02,676.04  852.02,444.903 444.484,444.903  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134234286023822372770000008996426075126462374_",
    gradientUnits: "userSpaceOnUse",
    x1: 665.7222,
    y1: 831.5988,
    x2: 634.2874,
    y2: 1106.3645,
    gradientTransform: "matrix(1 0 0 -1 -2.000000e-04 1544.8008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0131,
    style: {
      stopColor: "#0F0129"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1882,
    style: {
      stopColor: "#230B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#321247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#3A164F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D1751"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 447.903,
    y: 447.85,
    style: {
      fill: "url(#SVGID_00000134234286023822372770000008996426075126462374_)"
    },
    width: 400.693,
    height: 225.25
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085938014445596212680000011803585272676323202_",
    gradientUnits: "userSpaceOnUse",
    x1: -403.8399,
    y1: 395.6985,
    x2: -445.545,
    y2: 760.2349,
    gradientTransform: "matrix(-1 0 0 1 236.583 7.9826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "url(#SVGID_00000085938014445596212680000011803585272676323202_)"
    },
    d: "M451.083,493.34v-42.55 H845.41v40.04C809.406,512.149,636.799,552.972,451.083,493.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092419597044166699470000013936153543823840424_",
    gradientUnits: "userSpaceOnUse",
    x1: -378.8168,
    y1: 328.5855,
    x2: -417.792,
    y2: 669.2607,
    gradientTransform: "matrix(-1 0 0 1 236.583 7.9826)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.65,
      fill: "url(#SVGID_00000092419597044166699470000013936153543823840424_)"
    },
    d: "M845.41,577.196v92.958 H451.083v-88.658C496.543,705.515,828.537,671.483,845.41,577.196z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063603129495694582710000011134098598816610953_",
    gradientUnits: "userSpaceOnUse",
    x1: 649.2703,
    y1: 871.2972,
    x2: 649.2703,
    y2: 860.4731,
    gradientTransform: "matrix(1 0 0 -1 -2.000000e-04 1544.8008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.64,
      fill: "url(#SVGID_00000063603129495694582710000011134098598816610953_)"
    },
    d: "M850.071,683.654H448.469 c-4.592,0-8.343-3.751-8.343-8.343v-2.212c0,4.586,3.751,8.343,8.343,8.343h401.602c4.586,0,8.343-3.751,8.343-8.343v2.212 C858.414,679.902,854.657,683.654,850.071,683.654z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.64
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154398557288871482480000004304708530173951908_",
    gradientUnits: "userSpaceOnUse",
    x1: 466.6179,
    y1: 1110.6731,
    x2: 466.6179,
    y2: 1096.2947,
    gradientTransform: "matrix(1 0 0 -1 -2.000000e-04 1544.8008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154398557288871482480000004304708530173951908_)"
    },
    d: "M492.704,433.591l0.005,0.006 c1.272,2.625-0.648,5.671-3.559,5.671h-40.682c-4.592,0-8.343,3.751-8.343,8.343v-3.197c0-4.591,3.751-8.343,8.343-8.343h40.682 C490.861,436.07,492.121,434.985,492.704,433.591z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089554805420359018170000008018497312580794759_",
    gradientUnits: "userSpaceOnUse",
    x1: 668.3857,
    y1: 1143.7762,
    x2: 668.3857,
    y2: 1094.0962,
    gradientTransform: "matrix(1 0 0 -1 -2.000000e-04 1544.8008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089554805420359018170000008018497312580794759_)"
    },
    d: "M850.071,439.268H549.495 c-4.58,0-9.072-1.225-13.016-3.553l-56.271-33.168c-0.339-0.21-0.677-0.175-0.986-0.076l-0.735-1.534 c-0.531-1.097,0.676-2.211,1.721-1.587l56.271,33.168c3.944,2.328,8.436,3.553,13.016,3.553h300.576 c4.586,0,8.343,3.752,8.343,8.343v3.197C858.414,443.019,854.657,439.268,850.071,439.268z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00FFFF"
    },
    d: "M584.46,501.129v76.225h7.042c3.897,0,5.566,2.777,5.566,9.27v3.156 c0,6.488-1.669,9.271-5.566,9.271h-7.042v20.77c0,3.891-3.337,5.933-11.131,5.933h-5.198c-7.783,0-11.127-2.042-11.127-5.933 v-20.77h-48.588c-3.15,0-6.855-12.246-6.855-17.252c0-0.916,0.18-1.669,0.373-2.042l55.069-81.038 c2.229-3.157,5.946-3.53,11.319-3.53h5.006C581.123,495.189,584.46,497.231,584.46,501.129z M529.192,577.353h27.811V534.88 l-0.735-0.175L529.192,577.353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00FFFF"
    },
    d: "M692.201,560.475c0,41.732-16.505,66.394-43.949,66.394c-27.445,0-43.955-24.662-43.955-66.394 c0-41.727,16.51-66.394,43.955-66.394C675.696,494.081,692.201,518.748,692.201,560.475z M632.114,560.475 c0,29.486,5.753,44.69,16.138,44.69c10.385,0,16.132-15.204,16.132-44.69c0-29.492-5.747-44.697-16.132-44.697 C637.867,515.778,632.114,530.983,632.114,560.475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00FFFF"
    },
    d: "M782.884,501.129v76.225h7.048c3.898,0,5.566,2.777,5.566,9.27v3.156 c0,6.488-1.669,9.271-5.566,9.271h-7.048v20.77c0,3.891-3.337,5.933-11.126,5.933h-5.192c-7.795,0-11.132-2.042-11.132-5.933 v-20.77h-48.588c-3.15,0-6.861-12.246-6.861-17.252c0-0.916,0.186-1.669,0.373-2.042l55.081-81.038 c2.217-3.157,5.934-3.53,11.307-3.53h5.011C779.546,495.189,782.884,497.231,782.884,501.129z M727.621,577.353h27.812V534.88 l-0.741-0.175L727.621,577.353z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892,
    id: "SVGID_00000170991689454157890050000003668804993560058240_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000029730579573283165050000007297270184002779530_",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892,
    id: "SVGID_00000170991689454157890050000003668804993560058240_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000029730579573283165050000007297270184002779530_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000110458024407468780280000007699816333386927003_",
    cx: 480.9536,
    cy: 710.9644,
    r: 173.8432,
    gradientTransform: "matrix(1.4725 0 0 0.4779 -59.9522 178.7797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000170991689454157890050000003668804993560058240_)",
      fill: "url(#SVGID_00000110458024407468780280000007699816333386927003_)"
    },
    d: " M919.132,518.55c0,43.045-107.537,77.946-240.179,77.946c-132.643,0-301.58-34.901-301.58-77.946 c0-43.045,168.937-77.946,301.58-77.946C811.594,440.603,919.132,475.504,919.132,518.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000041986900126407505990000014519648163331748269_",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892,
    id: "SVGID_00000042706164841746956670000006555533823916873871_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000041986900126407505990000014519648163331748269_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000009590978450679259810000010768028014453425304_",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend3 || (_feBlend3 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 440.603,
    width: 541.759,
    height: 155.892,
    id: "SVGID_00000042706164841746956670000006555533823916873871_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000009590978450679259810000010768028014453425304_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000075844488317163729510000015247435347755360416_",
    cx: 480.9536,
    cy: 710.9644,
    r: 173.8432,
    gradientTransform: "matrix(1.4725 0 0 0.4779 -59.9522 178.7797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2711,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5118,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    style: {
      stopColor: "#A3A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#7B7B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000042706164841746956670000006555533823916873871_)",
      fill: "url(#SVGID_00000075844488317163729510000015247435347755360416_)"
    },
    d: " M919.132,518.55c0,43.045-107.537,77.946-240.179,77.946c-132.643,0-301.58-34.901-301.58-77.946 c0-43.045,168.937-77.946,301.58-77.946C811.594,440.603,919.132,475.504,919.132,518.55z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000099639914297168365750000008757193879678811826_",
    cx: 480.9536,
    cy: 710.9644,
    r: 173.8432,
    gradientTransform: "matrix(1.4725 0 0 0.4779 -59.9522 178.7797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "url(#SVGID_00000099639914297168365750000008757193879678811826_)"
    },
    d: "M919.132,518.55 c0,43.045-107.537,77.946-240.179,77.946c-132.643,0-301.58-34.901-301.58-77.946c0-43.045,168.937-77.946,301.58-77.946 C811.594,440.603,919.132,475.504,919.132,518.55z"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000133511604289612818570000007113898495721809823_",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88,
    id: "SVGID_00000145035686633352339290000000001796933079345068_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000133511604289612818570000007113898495721809823_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000072256175153790888910000005491063725049832088_",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend4 || (_feBlend4 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88,
    id: "SVGID_00000145035686633352339290000000001796933079345068_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000072256175153790888910000005491063725049832088_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013166739661684570900000017983105198431048592_",
    cx: 480.9536,
    cy: 886.4206,
    r: 173.8374,
    gradientTransform: "matrix(1.4725 0 0 0.4779 -59.9522 178.7797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000145035686633352339290000000001796933079345068_)",
      fill: "url(#SVGID_00000013166739661684570900000017983105198431048592_)"
    },
    d: " M919.132,602.394c0,43.051-107.537,77.946-240.179,77.946c-132.643,0-301.58-34.895-301.58-77.946 c0-43.045,168.937-77.934,301.58-77.934C811.594,524.46,919.132,559.349,919.132,602.394z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000103980325831239865570000012319386460500628380_",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend5 || (_feBlend5 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88,
    id: "SVGID_00000003827209091854957330000002644180778427968155_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000103980325831239865570000012319386460500628380_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000171698033256044160080000003906755635158523583_",
    filterUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend6 || (_feBlend6 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 377.372,
    y: 524.46,
    width: 541.759,
    height: 155.88,
    id: "SVGID_00000003827209091854957330000002644180778427968155_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000171698033256044160080000003906755635158523583_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000036241306982376630680000017713419274038470293_",
    cx: 480.9536,
    cy: 886.4206,
    r: 173.8374,
    gradientTransform: "matrix(1.4725 0 0 0.4779 -59.9522 178.7797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2711,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5118,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    style: {
      stopColor: "#A3A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#7B7B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000003827209091854957330000002644180778427968155_)",
      fill: "url(#SVGID_00000036241306982376630680000017713419274038470293_)"
    },
    d: " M919.132,602.394c0,43.051-107.537,77.946-240.179,77.946c-132.643,0-301.58-34.895-301.58-77.946 c0-43.045,168.937-77.934,301.58-77.934C811.594,524.46,919.132,559.349,919.132,602.394z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000090291599025725413430000006029315650408681348_",
    cx: 480.9536,
    cy: 886.4206,
    r: 173.8374,
    gradientTransform: "matrix(1.4725 0 0 0.4779 -59.9522 178.7797)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.54,
      fill: "url(#SVGID_00000090291599025725413430000006029315650408681348_)"
    },
    d: "M919.132,602.394 c0,43.051-107.537,77.946-240.179,77.946c-132.643,0-301.58-34.895-301.58-77.946c0-43.045,168.937-77.934,301.58-77.934 C811.594,524.46,919.132,559.349,919.132,602.394z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.39
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000113323129428507301900000005829342509950774971_",
    filterUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441,
    id: "SVGID_00000070096430972469980930000008506928173040949120_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000113323129428507301900000005829342509950774971_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000054229863075823010350000017023474545754809740_",
    filterUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend7 || (_feBlend7 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441,
    id: "SVGID_00000070096430972469980930000008506928173040949120_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000054229863075823010350000017023474545754809740_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000114073958804007899870000005620762655710997380_",
    cx: 759.9911,
    cy: 495.1031,
    r: 83.618,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000070096430972469980930000008506928173040949120_)",
      fill: "url(#SVGID_00000114073958804007899870000005620762655710997380_)"
    },
    points: " 489.84,523.141 588.042,523.141 588.042,501.7 489.84,501.7  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000051363323133223638780000011400010812073605026_",
    filterUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend8 || (_feBlend8 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441,
    id: "SVGID_00000076567612251339301710000004494847825227648431_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000051363323133223638780000011400010812073605026_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000049927126436490649730000009465464863755554973_",
    filterUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend9 || (_feBlend9 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 489.84,
    y: 501.7,
    width: 98.203,
    height: 21.441,
    id: "SVGID_00000076567612251339301710000004494847825227648431_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000049927126436490649730000009465464863755554973_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000117658854564209435300000004195214951459421876_",
    cx: 759.9911,
    cy: 495.1031,
    r: 83.618,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3562,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4692,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5696,
    style: {
      stopColor: "#D1D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    style: {
      stopColor: "#B6B6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7478,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#424242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000076567612251339301710000004494847825227648431_)",
      fill: "url(#SVGID_00000117658854564209435300000004195214951459421876_)"
    },
    points: " 489.84,523.141 588.042,523.141 588.042,501.7 489.84,501.7  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000121256208961269864840000016599937818029188522_",
    cx: 759.9911,
    cy: 495.1031,
    r: 83.618,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8646,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.77,
      fill: "url(#SVGID_00000121256208961269864840000016599937818029188522_)"
    },
    points: "489.84,523.141  588.042,523.141 588.042,501.7 489.84,501.7  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000113325658815395892760000009365456527585195911_",
    filterUnits: "userSpaceOnUse",
    x: 501.129,
    y: 604.786,
    width: 60.811,
    height: 12.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend10 || (_feBlend10 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 501.129,
    y: 604.786,
    width: 60.811,
    height: 12.1,
    id: "SVGID_00000030478922709428521830000013344536783114638236_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000113325658815395892760000009365456527585195911_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000138564119373334631310000017069612808588100513_",
    filterUnits: "userSpaceOnUse",
    x: 501.129,
    y: 604.786,
    width: 60.811,
    height: 12.1
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend11 || (_feBlend11 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 501.129,
    y: 604.786,
    width: 60.811,
    height: 12.1,
    id: "SVGID_00000030478922709428521830000013344536783114638236_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000138564119373334631310000017069612808588100513_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000167358117703916270190000013517378189708099714_",
    cx: 1041.2859,
    cy: 779.0851,
    r: 83.6145,
    gradientTransform: "matrix(-0.523 0 0 0.5641 1086.7847 161.5811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000030478922709428521830000013344536783114638236_)",
      fill: "url(#SVGID_00000167358117703916270190000013517378189708099714_)"
    },
    points: " 501.129,616.887 561.94,616.887 561.94,604.786 501.129,604.786  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000049907808492099866400000005422577367734128051_",
    cx: 1041.2859,
    cy: 779.0851,
    r: 83.6145,
    gradientTransform: "matrix(-0.523 0 0 0.5641 1086.7847 161.5811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.21,
      fill: "url(#SVGID_00000049907808492099866400000005422577367734128051_)"
    },
    points: "501.129,616.887  561.94,616.887 561.94,604.786 501.129,604.786  "
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000122702312765375520380000014769291602609006770_",
    filterUnits: "userSpaceOnUse",
    x: 733.736,
    y: 491.117,
    width: 48.075,
    height: 13.098
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend12 || (_feBlend12 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 733.736,
    y: 491.117,
    width: 48.075,
    height: 13.098,
    id: "SVGID_00000093896631779158392960000013856474653710298299_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000122702312765375520380000014769291602609006770_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000087404868738264267940000015405709859206856360_",
    filterUnits: "userSpaceOnUse",
    x: 733.736,
    y: 491.117,
    width: 48.075,
    height: 13.098
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend13 || (_feBlend13 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 733.736,
    y: 491.117,
    width: 48.075,
    height: 13.098,
    id: "SVGID_00000093896631779158392960000013856474653710298299_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000087404868738264267940000015405709859206856360_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000171706186793345583900000003879360506653080743_",
    cx: 730.4738,
    cy: 575.6354,
    r: 83.6021,
    gradientTransform: "matrix(-0.4135 0 0 0.611 1068.25 135.3733)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000093896631779158392960000013856474653710298299_)",
      fill: "url(#SVGID_00000171706186793345583900000003879360506653080743_)"
    },
    points: " 733.736,504.215 781.811,504.215 781.811,491.117 733.736,491.117  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000023972157690658172710000013087743253263567766_",
    cx: 730.4738,
    cy: 575.6354,
    r: 83.6021,
    gradientTransform: "matrix(-0.4135 0 0 0.611 1068.25 135.3733)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.21,
      fill: "url(#SVGID_00000023972157690658172710000013087743253263567766_)"
    },
    points: "733.736,504.215  781.811,504.215 781.811,491.117 733.736,491.117  "
  }), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000052810633674048443640000012906393323352574906_",
    filterUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392,
    id: "SVGID_00000141419391884107568270000006830310349211825298_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000052810633674048443640000012906393323352574906_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000003089659342150808310000012130032783455619243_",
    filterUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend14 || (_feBlend14 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392,
    id: "SVGID_00000141419391884107568270000006830310349211825298_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000003089659342150808310000012130032783455619243_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000080892631887069549950000001180279570574783382_",
    cx: 807.4052,
    cy: 980.6929,
    r: 83.6191,
    gradientTransform: "matrix(-0.523 0 0 0.3447 1086.7847 234.5369)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000141419391884107568270000006830310349211825298_)",
      fill: "url(#SVGID_00000080892631887069549950000001180279570574783382_)"
    },
    points: " 623.445,582.248 684.261,582.248 684.261,574.856 623.445,574.856  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000060012306673377848370000014026936120551122346_",
    filterUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend15 || (_feBlend15 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392,
    id: "SVGID_00000064317082649244239390000005715812160861718184_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000060012306673377848370000014026936120551122346_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000027575206847169768330000002467390160971489698_",
    filterUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend16 || (_feBlend16 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 623.445,
    y: 574.856,
    width: 60.817,
    height: 7.392,
    id: "SVGID_00000064317082649244239390000005715812160861718184_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000027575206847169768330000002467390160971489698_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000131326152785788642050000006706864589421800327_",
    cx: 807.4052,
    cy: 980.6929,
    r: 83.6191,
    gradientTransform: "matrix(-0.523 0 0 0.3447 1086.7847 234.5369)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2711,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5118,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    style: {
      stopColor: "#A3A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#7B7B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000064317082649244239390000005715812160861718184_)",
      fill: "url(#SVGID_00000131326152785788642050000006706864589421800327_)"
    },
    points: " 623.445,582.248 684.261,582.248 684.261,574.856 623.445,574.856  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000008133019250233902710000006099995362487713414_",
    cx: 807.4052,
    cy: 980.6929,
    r: 83.6191,
    gradientTransform: "matrix(-0.523 0 0 0.3447 1086.7847 234.5369)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.54,
      fill: "url(#SVGID_00000008133019250233902710000006099995362487713414_)"
    },
    points: "623.445,582.248  684.261,582.248 684.261,574.856 623.445,574.856  "
  })), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000109727430447520437170000016282697847585168818_",
    filterUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441,
    id: "SVGID_00000081630554443218628460000001176640449947586954_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000109727430447520437170000016282697847585168818_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000139265427667652629970000011352095807028510384_",
    filterUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend17 || (_feBlend17 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441,
    id: "SVGID_00000081630554443218628460000001176640449947586954_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000139265427667652629970000011352095807028510384_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000102508113198973301680000009691320711970882239_",
    cx: 478.5824,
    cy: 535.0856,
    r: 83.6132,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000081630554443218628460000001176640449947586954_)",
      fill: "url(#SVGID_00000102508113198973301680000009691320711970882239_)"
    },
    points: " 727.494,563.123 825.69,563.123 825.69,541.683 727.494,541.683  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000149339919552977387170000005337590813553438603_",
    filterUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend18 || (_feBlend18 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441,
    id: "SVGID_00000183965897514753168810000003475716697099957639_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000149339919552977387170000005337590813553438603_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000059304623605955318050000003000869552421853837_",
    filterUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend19 || (_feBlend19 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 727.494,
    y: 541.683,
    width: 98.197,
    height: 21.441,
    id: "SVGID_00000183965897514753168810000003475716697099957639_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000059304623605955318050000003000869552421853837_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000113332193610953142820000001901574425246707340_",
    cx: 478.5824,
    cy: 535.0856,
    r: 83.6132,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2204,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3562,
    style: {
      stopColor: "#F4F4F4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4692,
    style: {
      stopColor: "#E5E5E5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5696,
    style: {
      stopColor: "#D1D1D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6618,
    style: {
      stopColor: "#B6B6B6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7478,
    style: {
      stopColor: "#969696"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8292,
    style: {
      stopColor: "#6F6F6F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9069,
    style: {
      stopColor: "#424242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000183965897514753168810000003475716697099957639_)",
      fill: "url(#SVGID_00000113332193610953142820000001901574425246707340_)"
    },
    points: " 727.494,563.123 825.69,563.123 825.69,541.683 727.494,541.683  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000058547882067990685630000002772216444573569417_",
    cx: 478.5824,
    cy: 535.0856,
    r: 83.6132,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8646,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.77,
      fill: "url(#SVGID_00000058547882067990685630000002772216444573569417_)"
    },
    points: "727.494,563.123  825.69,563.123 825.69,541.683 727.494,541.683  "
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000155831526534312755430000009355258067179889584_",
    filterUnits: "userSpaceOnUse",
    x: 709.873,
    y: 624.36,
    width: 60.805,
    height: 12.094
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend20 || (_feBlend20 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 709.873,
    y: 624.36,
    width: 60.805,
    height: 12.094,
    id: "SVGID_00000118392833649276035190000014678661353294408065_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000155831526534312755430000009355258067179889584_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000147211763420713081870000014446429199379677865_",
    filterUnits: "userSpaceOnUse",
    x: 709.873,
    y: 624.36,
    width: 60.805,
    height: 12.094
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend21 || (_feBlend21 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 709.873,
    y: 624.36,
    width: 60.805,
    height: 12.094,
    id: "SVGID_00000118392833649276035190000014678661353294408065_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000147211763420713081870000014446429199379677865_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000017499122585081320480000010593300972168471455_",
    cx: 642.1636,
    cy: 813.7872,
    r: 83.6032,
    gradientTransform: "matrix(-0.523 0 0 0.5641 1086.7847 161.5811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000118392833649276035190000014678661353294408065_)",
      fill: "url(#SVGID_00000017499122585081320480000010593300972168471455_)"
    },
    points: " 709.873,636.454 770.679,636.454 770.679,624.36 709.873,624.36  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000091012855520168653790000002261485039935723653_",
    cx: 642.1636,
    cy: 813.7872,
    r: 83.6032,
    gradientTransform: "matrix(-0.523 0 0 0.5641 1086.7847 161.5811)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.21,
      fill: "url(#SVGID_00000091012855520168653790000002261485039935723653_)"
    },
    points: "709.873,636.454  770.679,636.454 770.679,624.36 709.873,624.36  "
  }), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000157303394178294871750000009094457925699213991_",
    filterUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441,
    id: "SVGID_00000164482824837489982550000014442804740974818968_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000157303394178294871750000009094457925699213991_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000021080736126690796460000004894144617664922013_",
    filterUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend22 || (_feBlend22 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441,
    id: "SVGID_00000164482824837489982550000014442804740974818968_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000021080736126690796460000004894144617664922013_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000059286452939919116770000000003949616544416955_",
    cx: 694.7803,
    cy: 511.1418,
    r: 147.9015,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000164482824837489982550000014442804740974818968_)",
      fill: "url(#SVGID_00000059286452939919116770000000003949616544416955_)"
    },
    points: " 638.97,498.941 655.218,498.941 655.218,477.5 638.97,477.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000179644112904011123900000002549364570299018667_",
    filterUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend23 || (_feBlend23 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441,
    id: "SVGID_00000128482607043494673420000016825280570385670794_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000179644112904011123900000002549364570299018667_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000003105086476100128730000015820388297836991367_",
    filterUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend24 || (_feBlend24 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 638.97,
    y: 477.5,
    width: 16.248,
    height: 21.441,
    id: "SVGID_00000128482607043494673420000016825280570385670794_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000003105086476100128730000015820388297836991367_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119801428461848520740000016292731058056228512_",
    cx: 694.7803,
    cy: 511.1418,
    r: 147.9015,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2711,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5118,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    style: {
      stopColor: "#A3A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#7B7B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000128482607043494673420000016825280570385670794_)",
      fill: "url(#SVGID_00000119801428461848520740000016292731058056228512_)"
    },
    points: " 638.97,498.941 655.218,498.941 655.218,477.5 638.97,477.5  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000123438843460116010740000008630401041828622521_",
    cx: 694.7803,
    cy: 511.1418,
    r: 147.9015,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.54,
      fill: "url(#SVGID_00000123438843460116010740000008630401041828622521_)"
    },
    points: "638.97,498.941  655.218,498.941 655.218,477.5 638.97,477.5  "
  })), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000176761851660591402980000015830499127366548869_",
    filterUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094,
    id: "SVGID_00000075844601844405863150000000807125826617128069_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000176761851660591402980000015830499127366548869_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000035524397452410515130000013063805943298651803_",
    filterUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend25 || (_feBlend25 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094,
    id: "SVGID_00000075844601844405863150000000807125826617128069_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000035524397452410515130000013063805943298651803_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000041290533902323733770000001281896454507049918_",
    cx: 706.9944,
    cy: 532.2226,
    r: 147.9236,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1056,
    style: {
      stopColor: "#DCDCDC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3567,
    style: {
      stopColor: "#8F8F8F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5806,
    style: {
      stopColor: "#525252"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7691,
    style: {
      stopColor: "#252525"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9148,
    style: {
      stopColor: "#0A0A0A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000075844601844405863150000000807125826617128069_)",
      fill: "url(#SVGID_00000041290533902323733770000001281896454507049918_)"
    },
    points: " 628.9,613.479 638.97,613.479 638.97,601.384 628.9,601.384  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000143590717057323956150000000640070696223035027_",
    filterUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend26 || (_feBlend26 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094,
    id: "SVGID_00000145029032793788527390000017160295564253340049_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000143590717057323956150000000640070696223035027_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000061466172000732312900000012062896159122299311_",
    filterUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend27 || (_feBlend27 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 628.9,
    y: 601.384,
    width: 10.07,
    height: 12.094,
    id: "SVGID_00000145029032793788527390000017160295564253340049_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000061466172000732312900000012062896159122299311_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000085239416404601323090000000725904032889128124_",
    cx: 706.9944,
    cy: 532.2226,
    r: 147.9236,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1432,
    style: {
      stopColor: "#FBFBFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2711,
    style: {
      stopColor: "#F1F1F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3932,
    style: {
      stopColor: "#DEDEDE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5118,
    style: {
      stopColor: "#C5C5C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6279,
    style: {
      stopColor: "#A3A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    style: {
      stopColor: "#7B7B7B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    style: {
      stopColor: "#4B4B4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9632,
    style: {
      stopColor: "#141414"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      mask: "url(#SVGID_00000145029032793788527390000017160295564253340049_)",
      fill: "url(#SVGID_00000085239416404601323090000000725904032889128124_)"
    },
    points: " 628.9,613.479 638.97,613.479 638.97,601.384 628.9,601.384  "
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000013879517179036230690000004988980032280590766_",
    cx: 706.9944,
    cy: 532.2226,
    r: 147.9236,
    gradientTransform: "matrix(-0.8445 0 0 1 1197.9651 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9453,
    style: {
      stopColor: "#00FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00FFFF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.54,
      fill: "url(#SVGID_00000013879517179036230690000004988980032280590766_)"
    },
    points: "628.9,613.479  638.97,613.479 638.97,601.384 628.9,601.384  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      fill: "#FFE266"
    },
    d: "M738.952,747.801c4.352-2.847,8.81-5.618,13.028-8.64 c-3.08,4.556-6.459,8.086-9.043,12.917c2.048-0.648,9.311-2.054,10.595-3.413c-3.203,3.401-7.573,5.846-11.091,8.92 c3.985,0.566,9.224,0.21,12.556,2.602c-4.405,1.838-11.424,2.719-16.313,2.561c1.033,0.899,1.768,2.153,1.814,3.553 c-1.155-0.204-2.462-0.735-3.442-1.476c0.753,0.822,1.499,1.89,2.048,2.923c-2.555-0.682-9.095-3.361-9.557-6.167 c-4.58,4.002-9.767,7.55-13.903,11.949c1.703-5.187,4.906-12.649,9.614-15.91c-1.295,0.192-2.596,0.099-3.804-0.333 c1.902-0.577,4.242-0.793,5.362-2.549c-1.681-1.05-4.457-0.671-5.052-2.462c1.808-0.082,3.739-0.286,5.443,0.303 c-0.006-3.477-0.234-7.252,0.012-10.81c-0.152,2.205,4.019,7.059,4.749,9.375c0.373-1.552,0.974-3.641,1.715-5.344 c0.356,1.546,0.764,3.255,1.802,4.306C736.63,749.33,737.791,748.566,738.952,747.801z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#071F48"
    },
    d: "M440.808,816.996c-3.022,0-5.956-0.122-8.798-0.362c-28.92-2.485-57.147-35.577-83.885-98.378 c-19.032-44.713-30.415-88.027-30.887-89.854l19.393-5.058c17.03,65.257,58.454,170.005,97.094,173.313 c26.884,2.31,66.546-9.37,108.541-21.727c48.652-14.323,98.938-29.154,142.76-27.27l-0.858,20.029 c-40.484-1.709-89.159,12.608-136.242,26.47C508.142,805.865,470.353,816.996,440.808,816.996z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010995593279241750880000015253369027308971931_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.8219,
    y1: 334.1485,
    x2: 165.7497,
    y2: 449.3278
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010995593279241750880000015253369027308971931_)"
    },
    d: "M142.863,453.206 c-3.11-0.904-28.821-81.715-26.389-96.371c0,0,4.364-2.316,5.333,0c0.968,2.328,21.056,58.413,21.056,58.413V453.206z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000139984804661855712370000009844969221317458828_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.7889,
    y1: 331.9059,
    x2: 168.7208,
    y2: 447.0905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "url(#SVGID_00000139984804661855712370000009844969221317458828_)"
    },
    d: "M120.862,372.786 c4.166,23.64,12.41,46.26,22.001,68.232v-25.77c0,0-20.087-56.085-21.056-58.413c-0.484-1.167-1.82-1.155-3.034-0.863 C119.194,361.608,119.871,367.22,120.862,372.786z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121270128652180454430000002127136876872736897_",
    gradientUnits: "userSpaceOnUse",
    x1: 668.5435,
    y1: 257.5551,
    x2: 755.869,
    y2: 373.2614,
    gradientTransform: "matrix(-0.9401 0.3408 0.3408 0.9401 983.9536 -201.9231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121270128652180454430000002127136876872736897_)"
    },
    d: "M423.51,402.407 c2.62-1.92-0.764-87.042-8.069-100.046c0,0-4.918-0.706-5.035,1.82c-0.122,2.538,0.105,62.374,0.105,62.374L423.51,402.407z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000097475735832210224850000008674806344756402085_",
    gradientUnits: "userSpaceOnUse",
    x1: 671.5268,
    y1: 255.3026,
    x2: 758.8511,
    y2: 371.0072,
    gradientTransform: "matrix(-0.9401 0.3408 0.3408 0.9401 983.9536 -201.9231)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "url(#SVGID_00000097475735832210224850000008674806344756402085_)"
    },
    d: "M416.759,318.924 c4.16,23.745,4.119,47.929,2.573,71.966l-8.822-24.335c0,0-0.227-59.836-0.105-62.374c0.058-1.261,1.324-1.71,2.567-1.85 C414.501,307.792,415.779,313.329,416.759,318.924z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120526205993094657570000000936213997653558414_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.5907,
    y1: 436.8267,
    x2: 194.5112,
    y2: 534.2394,
    gradientTransform: "matrix(0.9751 0.2217 -0.2217 0.9751 86.3431 -76.7536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120526205993094657570000000936213997653558414_)"
    },
    d: "M157.601,377.809L157.601,377.809 c0,0-14.825,11.505-18.162,20.495c-3.349,8.991,0.536,72.351,11.079,74.381l0,0C150.868,445.802,154.235,404.133,157.601,377.809z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029749695761595634930000011955805274500545922_",
    gradientUnits: "userSpaceOnUse",
    x1: 387.5388,
    y1: 321.8614,
    x2: 421.3702,
    y2: 419.0184,
    gradientTransform: "matrix(0.9777 -0.21 0.21 0.9777 -57.6114 114.418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029749695761595634930000011955805274500545922_)"
    },
    d: "M411.188,356.147 c-5.455-7.375-21.616-14.031-23.033-14.603c10.735,24.323,25.746,63.121,33.699,88.657 C430.073,422.768,416.759,363.655,411.188,356.147z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166652755212950122720000015584668750541903805_",
    gradientUnits: "userSpaceOnUse",
    x1: 160.9292,
    y1: 436.7088,
    x2: 194.8496,
    y2: 534.1216,
    gradientTransform: "matrix(0.9751 0.2217 -0.2217 0.9751 86.3431 -76.7536)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "url(#SVGID_00000166652755212950122720000015584668750541903805_)"
    },
    d: "M150.518,472.686 c0.35-26.884,3.717-68.553,7.083-94.877c0,0-0.992,0.77-2.503,2.059c-1.208,25.443-0.992,52.585-12.655,75.688 C144.433,465.032,147.134,472.039,150.518,472.686L150.518,472.686z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059295640366698051110000003264395132449052831_",
    gradientUnits: "userSpaceOnUse",
    x1: 383.3728,
    y1: 323.3121,
    x2: 417.2042,
    y2: 420.4691,
    gradientTransform: "matrix(0.9777 -0.21 0.21 0.9777 -57.6114 114.418)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "url(#SVGID_00000059295640366698051110000003264395132449052831_)"
    },
    d: "M421.135,410.301 c-7.923-13.722-14.399-28.086-19.866-42.94c-2.725-7.404-6.225-15.426-7.83-23.46c-2.748-1.313-4.819-2.165-5.286-2.357 c10.735,24.323,25.746,63.121,33.699,88.657c2.404-2.164,2.958-8.769,2.409-17.187C423.049,412.558,421.946,411.7,421.135,410.301 z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M104.532,497.791c3.139,1.639,6.12,3.623,8.938,6.114c6.972,6.167,12.602,13.664,18.262,21.003 c1.785,2.305,1.983,2.69,4.72,1.476c1.342-0.595,6.348-3.144,6.593-4.883c0.228-1.651-3.641-6.599-4.498-8.255 c-1.167-2.258-1.984-4.265-2.141-6.844c-0.228-3.641,0.111-6.721-1.441-10.193c-2.468-5.496-8.326-8.15-11.441-13.086 c-1.517-2.404-1.464-4.866-2.491-7.34c-1.511-3.617-6.306-4.399-8.168-0.525c-1.914,4.002-0.542,9.031,1.424,12.579 c-0.268-0.484-5.222-2.112-6.137-2.789c-2.083-1.529-3.944-3.372-6.505-4.084c-2.631-0.724-1.972,0.519-3.734,0.747 c-1.698,0.216-4.032-1.289-5.962-1.231c-3.139,0.094-6.966,1.354-9.212,3.588c-5.146,5.122,1.528,7.054,5.77,8.075 C94.223,493.503,99.573,495.207,104.532,497.791z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000941150099028564960000004215505484848259731_",
    gradientUnits: "userSpaceOnUse",
    x1: -2614.1147,
    y1: 814.5475,
    x2: -2579.2563,
    y2: 884.8977,
    gradientTransform: "matrix(-0.9777 0.2101 0.2101 0.9777 -2564.0911 271.0099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000941150099028564960000004215505484848259731_)"
    },
    d: "M184.549,547.103 c5.478,5.665,19.399,46.761,10.198,47.438c-9.206,0.683-81.761-65.408-82.438-86.668c-0.175-5.484,23.518,5.688,23.518,5.688 l7.62-1.633L184.549,547.103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M287.478,669.978c0,16.015-12.982,28.996-28.996,28.996c-16.015,0-28.996-12.982-28.996-28.996 c0-16.015,12.981-29.002,28.996-29.002C274.496,640.976,287.478,653.963,287.478,669.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M297.939,673.782c0,16.015,12.981,28.996,28.996,28.996c16.015,0,28.996-12.981,28.996-28.996 c0-16.021-12.982-29.002-28.996-29.002C310.92,644.78,297.939,657.761,297.939,673.782z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051367289108480747700000007732186831718333857_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.3717,
    y1: 533.5472,
    x2: 363.5936,
    y2: 711.4604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000051367289108480747700000007732186831718333857_)"
    },
    d: "M251.369,518.018 c-1.271,1.902-32.958,82.391-20.286,136.271c0,0,35.496-10.006,43.086,45.63c0,0,3.892,3.821,10.952,5.239 c7.059,1.43,17.269,0.473,24.562-0.163c0,0,20.916-48.174,46.902-48.804l3.173-127.514l-6.972-14.463l-53.244-1.908 L251.369,518.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M304.613,505.586c-4.674,0.91-16.033,1.178-30.444,0.933c0,0,3.186,14.662,3.186,14.667 c5.42,10.006,25.723,9.3,34.749,5.339c4.848-2.124,7.007-6.575,8.255-11.465c0.443-1.698,1.179-14.469,2.013-14.749 C314.373,503.013,308.061,504.909,304.613,505.586z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.207,
    y: 686.061,
    transform: "matrix(0.8661 0.4998 -0.4998 0.8661 384.6539 -23.3848)",
    style: {
      fill: "#3C4B6D"
    },
    width: 21.549,
    height: 40.63
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C4B6D"
    },
    points: "343.177,730.684 363.142,722.568 350.301,690.958 331.013,700.737  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106861281621719033390000017740292139951227323_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.3223,
    y1: 719.0523,
    x2: 264.825,
    y2: 820.4183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106861281621719033390000017740292139951227323_)"
    },
    d: "M204.468,687.248 c0,0,44.994,38.034,46.901,46.908c1.902,8.874-0.752,85.198-0.752,85.198s-37.579,2.917-40.746-2.159 c-3.174-5.07,13.378-8.326,13.378-8.326S194.952,693.589,204.468,687.248z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039854217196387227970000006873611916970180011_",
    gradientUnits: "userSpaceOnUse",
    x1: -2837.9988,
    y1: 724.5264,
    x2: -2772.3528,
    y2: 811.5073,
    gradientTransform: "matrix(-1 0 0 1 -2437.0781 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039854217196387227970000006873611916970180011_)"
    },
    d: "M373.283,686.834 c0,0-36.435,34.977-38.337,43.85c-1.902,8.874,21.546,86.721,21.546,86.721s34.253,4.446,37.421-0.624 c3.174-5.07-10.402-9.154-10.402-9.154S382.792,693.175,373.283,686.834z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137814099974587732720000002629049407426955925_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.6154,
    y1: 539.5336,
    x2: 345.0826,
    y2: 697.2347
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    style: {
      stopColor: "#A4D6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#87BCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "url(#SVGID_00000137814099974587732720000002629049407426955925_)"
    },
    d: "M347.075,649.062 c0,0-30.928,14.259-39.137,44.212c0,0-25.636,6.342-35.397-2.544l0,0c0.63,2.847,1.179,5.904,1.627,9.189 c0,0,3.892,3.821,10.952,5.239c7.059,1.43,17.269,0.473,24.562-0.163c0,0,20.916-48.174,46.902-48.804l3.173-127.514l-6.972-14.463 C352.786,514.215,343.276,622.44,347.075,649.062z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183966760386857751890000004164399489305327007_",
    gradientUnits: "userSpaceOnUse",
    x1: 247.8881,
    y1: 269.3994,
    x2: 291.7365,
    y2: 464.3335
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183966760386857751890000004164399489305327007_)"
    },
    d: "M383.673,329.315 c-5.864-8.227-12.532-15.852-21.464-22.736c-32.363-24.935-70.28-31.826-110.204-23.978c-32.654,6.423-59.142,25.408-76.54,53.529 c-11.22,18.139-18.326,36.208-22.573,57.059c-3.932,19.335-6.12,37.69-4.323,57.334c0.904,9.947,3.127,38.185,11.686,45.309 c8.523,7.095,126.324,13.279,144.358,9.755c18.034-3.53,114.276-40.484,120.337-49.83c3.436-5.303,0.864-16.996,0.397-22.736 c-2.036-25.233-9.848-53.034-23.238-74.451C395.639,348.218,390.144,338.399,383.673,329.315z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000055686632593424467820000008234767573886595717_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.2488,
    y1: 504.0631,
    x2: 253.4232,
    y2: 362.9199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000055686632593424467820000008234767573886595717_)"
    },
    d: "M368.026,366.835 c-38.664-32.333-93.191-44.924-140.868-22.812c-26.791,12.427-45.735,38.523-56.914,65.04 c-7.194,17.054-10.991,36.902-10.677,55.455c0.006,0.507,0.023,1.02,0.041,1.528c0.601,15.548,2.672,21.068,17.106,23.763 c13.921,2.608,28.128,3.956,42.206,5.292c24.977,2.375,54.264,7.76,79.265,3.378c24.358-4.276,48.792-15.157,71.785-23.897 c12.818-4.866,25.712-9.772,38.092-15.689c3.944-1.884,10.747-4.154,12.135-8.535c1.995-6.307-6.242-24.195-9.212-29.848 c-2.888-5.507-5.84-11.242-9.177-16.447c-6.645-10.409-15.257-19.539-23.921-28.214 C374.729,372.698,371.439,369.694,368.026,366.835z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000174597355748856030760000002589228537987070342_",
    gradientUnits: "userSpaceOnUse",
    x1: 296.7108,
    y1: 493.5675,
    x2: 274.9575,
    y2: 380.139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0131,
    style: {
      stopColor: "#0F0129"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1882,
    style: {
      stopColor: "#230B3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    style: {
      stopColor: "#321247"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6215,
    style: {
      stopColor: "#3A164F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3D1751"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000174597355748856030760000002589228537987070342_)"
    },
    d: "M343.936,355.627 c-42.982-28.687-116.546-20.029-148.5,21.75c-31.388,41.021-33.634,100.017-25.741,105.892 c7.853,5.852,111.114,14.387,127.748,11.47c16.633-2.899,110.77-36.808,116.358-44.521 C419.391,442.506,385.744,383.527,343.936,355.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18FFFF"
    },
    d: "M305.733,408.836c2.374,4.569,13.897,24.662,32.077,21.453 c10.624-1.879,15.082-11.366,16.919-20.076C338.405,408.287,321.97,407.138,305.733,408.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18FFFF"
    },
    d: "M237.133,417.862c-8.786,2.059-16.954,5.694-24.918,9.778c3.571,6.109,9.09,11.663,17.555,12.906 c17.462,2.585,25.717-19.382,27.818-26.091C250.733,415.353,243.878,416.275,237.133,417.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M504.069,480.953c-3.139,1.639-6.12,3.629-8.938,6.12c-6.978,6.167-12.608,13.664-18.267,20.998 c-1.785,2.31-1.983,2.69-4.714,1.482c-1.348-0.6-6.348-3.15-6.593-4.883c-0.234-1.645,3.635-6.599,4.493-8.262 c1.167-2.258,1.983-4.27,2.147-6.838c0.228-3.646-0.111-6.732,1.441-10.192c2.463-5.496,8.326-8.151,11.435-13.093 c1.523-2.404,1.464-4.866,2.491-7.339c1.511-3.617,6.307-4.405,8.168-0.531c1.914,4.002,0.543,9.043-1.418,12.584 c0.262-0.478,5.221-2.106,6.137-2.789c2.077-1.528,3.944-3.378,6.506-4.084c2.631-0.729,1.972,0.525,3.734,0.747 c1.692,0.21,4.031-1.283,5.957-1.225c3.139,0.088,6.966,1.354,9.218,3.583c5.146,5.122-1.528,7.059-5.77,8.068 C514.379,476.671,509.029,478.375,504.069,480.953z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152970140078868821600000014807214197865242793_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.2404,
    y1: 219.8354,
    x2: 108.1016,
    y2: 290.1917,
    gradientTransform: "matrix(0.9777 0.2101 -0.2101 0.9777 420.3119 271.0099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152970140078868821600000014807214197865242793_)"
    },
    d: "M424.047,530.271 c-5.478,5.659-19.399,46.756-10.193,47.438c9.206,0.683,81.756-65.408,82.433-86.668c0.175-5.49-23.512,5.689-23.512,5.689 l-7.62-1.64L424.047,530.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#253A5F"
    },
    d: "M688.036,757.842c-0.303,5.537-2.229,9.936-4.306,9.825c-2.077-0.116-3.518-4.69-3.215-10.227 c0.297-5.536,2.228-9.93,4.3-9.819C686.898,747.732,688.334,752.305,688.036,757.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#071F48"
    },
    d: "M686.735,757.779c-0.234,4.382-1.534,7.87-2.888,7.795c-1.359-0.076-2.27-3.687-2.031-8.069 c0.245-4.376,1.529-7.871,2.894-7.795C686.064,749.786,686.974,753.397,686.735,757.779z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF1B22"
    },
    d: "M683.118,750.8c-0.823,1.949-1.155,4.072-1.266,6.237c10.023-0.846,19.714-1.079,27.882,0.724 l1.313-5.968C702.622,749.937,693.001,750.036,683.118,750.8z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6F73"
    },
    d: "M711.414,755.007c-0.385,1.651-1.19,2.865-1.808,2.725c-0.618-0.146-0.805-1.599-0.426-3.238 c0.385-1.651,1.19-2.865,1.809-2.725C711.607,751.921,711.799,753.362,711.414,755.007z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B80000"
    },
    d: "M711.029,754.914c-0.303,1.307-0.881,2.281-1.283,2.194c-0.403-0.094-0.484-1.231-0.175-2.533 c0.297-1.295,0.869-2.275,1.277-2.182C711.245,752.481,711.332,753.619,711.029,754.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF981D"
    },
    d: "M718.304,755.299v-0.011h-0.012c-0.011-0.006-0.017-0.006-0.017-0.018c-0.012,0-0.023,0-0.029,0 c-2.445-1.062-5.164-1.814-8.022-2.404c-0.204,0.257-0.887,1.435-0.84,3.279c2.806,0.554,5.234,1.261,7.556,2.276l0.011-0.017 c0.333,0.029,0.846-0.514,1.202-1.313C718.526,756.262,718.584,755.48,718.304,755.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#FF981D"
    },
    d: "M716.467,757.562c-0.432-0.117-0.87-0.204-1.301-0.309 c-1.056-0.24-2.182-0.531-3.098-1.132c-0.479-0.321-0.922-0.724-1.173-1.254c-0.309-0.642-0.245-1.249-0.122-1.879 c-0.186-0.041-0.361-0.082-0.548-0.122c-0.204,0.257-0.887,1.435-0.84,3.279c2.806,0.554,5.234,1.261,7.556,2.276l0.011-0.017 c0.216,0.017,0.502-0.216,0.782-0.601C717.301,757.802,716.869,757.673,716.467,757.562z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M714.64,755.619c1.015,0.572,2.112,1.004,3.249,1.278c0.31-0.729,0.356-1.418,0.099-1.575 l0.006-0.005c-0.006,0-0.011,0-0.017,0c-0.006,0-0.006-0.012-0.017-0.012c-0.006-0.006-0.018-0.006-0.024-0.006 c-1.867-0.817-3.926-1.394-6.062-1.896C712.516,754.347,713.654,755.054,714.64,755.619z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77A400"
    },
    d: "M681.782,757.399c-0.146,2.065,0.035,4.125,0.583,6.097c9.277-0.694,18.197-0.787,25.794,0.875 l1.318-5.963C701.105,756.565,691.583,756.658,681.782,757.399z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9CCE00"
    },
    d: "M709.839,761.629c-0.379,1.645-1.19,2.865-1.809,2.719c-0.618-0.146-0.811-1.599-0.425-3.238 c0.379-1.645,1.196-2.865,1.809-2.725C710.031,758.525,710.224,759.978,709.839,761.629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B80000"
    },
    d: "M709.453,761.541c-0.309,1.301-0.869,2.282-1.289,2.182c-0.397-0.093-0.478-1.219-0.169-2.526 c0.298-1.301,0.869-2.281,1.278-2.188C709.67,759.108,709.757,760.234,709.453,761.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF981D"
    },
    d: "M716.723,761.914L716.723,761.914c-0.006-0.011-0.006-0.011-0.006-0.011 c-0.011,0-0.017-0.006-0.023-0.006c-0.005-0.011-0.017-0.011-0.029-0.011c-2.439-1.062-5.152-1.814-8.016-2.398 c-0.21,0.239-0.887,1.43-0.841,3.261c2.807,0.566,5.233,1.272,7.556,2.287l0.006-0.029c0.332,0.053,0.851-0.507,1.207-1.301 C716.951,762.878,717.015,762.096,716.723,761.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#FF981D"
    },
    d: "M714.885,764.179c-0.426-0.117-0.863-0.21-1.295-0.309 c-1.056-0.239-2.188-0.519-3.098-1.126c-0.484-0.327-0.922-0.723-1.173-1.254c-0.31-0.642-0.24-1.255-0.122-1.885 c-0.187-0.035-0.368-0.081-0.548-0.117c-0.21,0.239-0.887,1.43-0.841,3.261c2.807,0.566,5.233,1.272,7.556,2.287l0.006-0.029 c0.216,0.035,0.507-0.204,0.781-0.578C715.731,764.429,715.288,764.289,714.885,764.179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M713.065,762.236c1.01,0.583,2.107,1.015,3.25,1.289c0.309-0.741,0.35-1.424,0.104-1.587l0,0 c-0.011,0-0.011-0.012-0.017-0.012c-0.006-0.006-0.011-0.006-0.011-0.012c-0.012,0-0.023,0-0.029,0 c-1.867-0.805-3.927-1.394-6.068-1.896C710.941,760.964,712.079,761.67,713.065,762.236z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.57
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#071F48"
    },
    d: "M403.393,784.64c3.892,7.578,9.271,14.632,16.325,19.516c8.144,5.63,17.812,7.053,27.549,6.931 c11.546-0.14,22.934-2.549,34.066-5.403c23.331-5.992,46.389-12.923,69.276-20.419c23.781-7.777,47.538-16.173,72.094-21.226 c6.085-1.254,12.2-2.398,18.29-3.687c5.426-1.155,11.033-2.188,16.254-4.119c3.419-1.249,6.593-3.11,8.973-5.898 c0.7-0.823,1.307-1.704,1.855-2.614c-39.585,1.808-83.319,14.696-125.811,27.211c-41.995,12.357-81.656,24.037-108.541,21.727 c-12.136-1.039-24.545-12.083-36.388-28.775C398.633,773.7,400.68,779.371,403.393,784.64z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M727.966,750.725c-0.858-0.584-1.932-0.805-3.005-0.799c1.523-1.278,3.6-2.696,5.578-2.905 c-0.758-1.908-3.506-1.459-5.14-0.939c-1.634,0.519-3.052,1.511-4.119,2.864c-0.304,0.373-2.147,4.341-2.135,4.353 c0.333,0.397,5.07-1.149,5.759-1.255c1.324-0.198,2.684-0.298,4.031-0.356C728.666,751.285,728.339,750.97,727.966,750.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M731.291,754.64c-0.059-0.373-0.146-0.689-0.443-0.963c-0.088-0.081-0.169-0.14-0.268-0.204 c-0.082-0.058-0.292-0.246,0,0.029c-0.292-0.274-0.554-0.414-0.928-0.501c-0.263-0.07-0.508-0.128-0.776-0.146 c-0.245-0.023-0.49-0.005-0.735,0.012c-0.088,0.006-0.175,0.006-0.257,0.017c-0.111,0.041-0.216,0.07-0.327,0.105 c0.181-0.047,0.21-0.064,0.064-0.041c-0.104,0.005-0.216,0.041-0.321,0.076c-0.064,0.017-0.14,0.041-0.198,0.081 c-0.14,0.041-0.391,0.117-0.332,0.094c-0.059,0.023-0.111,0.064-0.17,0.099c-0.157,0.058-0.315,0.117-0.443,0.175 c-0.157,0.064-0.303,0.122-0.42,0.274c-0.064,0.029-0.128,0.058-0.181,0.105c-0.035,0.035-0.053,0.064-0.064,0.111 c-0.041-0.017-0.082,0-0.117,0.029c-0.088,0.053-0.111,0.198,0.005,0.233c0.128,0.041,0.274,0.099,0.385,0.175 c-0.07,0.006-0.041,0.053,0.076,0.099c0.041,0.023,0.082,0.053,0.128,0.065c0.076,0.035,0.169,0.047,0.245,0.076 c-0.064-0.023,0.192,0.099,0.239,0.117c0.018,0.012,0.14,0.053,0.158,0.053c0.105,0.058,0.204,0.128,0.321,0.175 c0.041,0.011,0.059,0.011,0.07,0.023c0.041,0.023,0.076,0.059,0.122,0.076c0.111,0.059,0.222,0.105,0.339,0.158 c0.081,0.029,0.053,0.017-0.099-0.041c0.117,0.065,0.222,0.122,0.344,0.164c0.163,0.076,0.327,0.152,0.496,0.216 c0.181,0.064,0.35,0.122,0.525,0.181c0.14,0.035,0.274,0.076,0.414,0.11c0.105,0.018,0.198,0.006,0.297,0.006 c-0.011,0-0.017,0-0.023,0c0.204,0.012,0.415,0.035,0.618,0.017c0.309-0.005,0.543-0.104,0.788-0.28 c-0.023,0-0.053,0.005-0.076,0.017c0.087-0.052,0.163-0.105,0.245-0.169C731.239,755.281,731.332,754.931,731.291,754.64z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M724.558,758.881C724.57,758.881,724.558,758.881,724.558,758.881L724.558,758.881L724.558,758.881 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M726.431,758.863c-0.023-0.041-0.047-0.087-0.058-0.128c-0.018-0.029-0.029-0.041-0.041-0.07 c-0.087-0.146-0.128-0.198-0.262-0.304c-0.122-0.11-0.257-0.186-0.409-0.251c-0.053-0.017-0.11-0.035-0.163-0.053 c-0.134-0.029-0.245-0.064-0.379-0.041c-0.023,0-0.041,0.029-0.064,0.035c-0.152,0-0.298,0.023-0.426,0.117l0,0 c0.047-0.023,0.087-0.041,0.128-0.064c-0.023,0.005-0.052,0.005-0.075,0.023c-0.029,0-0.035,0.023-0.053,0.023 c-0.029,0.011-0.058,0.017-0.082,0.017c-0.187,0.035-0.315,0.192-0.303,0.373c0.012,0.175,0.128,0.28,0.286,0.321 c0.023,0.017,0.029,0.035,0.047,0.047c-0.006-0.011-0.023-0.017-0.029-0.035c0.006,0,0.006,0.005,0.011,0.005l0,0l0,0 c0.006,0,0.006,0,0.006,0c0.023,0.012,0.006,0-0.006,0c0.047,0.052,0.076,0.099,0.134,0.152c0.012,0,0.017,0.006,0.023,0.006 c0.059,0.076,0.128,0.14,0.204,0.198c0.047,0.035,0.105,0.088,0.158,0.134c-0.041-0.047-0.088-0.088-0.134-0.122 c0.093,0.081,0.181,0.151,0.28,0.233c0.093,0.076,0.192,0.122,0.298,0.175c-0.047-0.029-0.099-0.053-0.146-0.076 c0.134,0.065,0.245,0.158,0.361,0.245c0.169,0.128,0.409,0.117,0.584,0.012c0.076-0.053,0.134-0.111,0.175-0.192 c0.064-0.117,0.064-0.204,0.058-0.333C726.542,759.167,726.484,759.009,726.431,758.863z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M724.237,767.533c0.076-0.169,0.099-0.339,0.082-0.508c0-0.006,0-0.006,0-0.017 c0,0.011,0,0.011,0,0.017c-0.017-0.093-0.041-0.175-0.076-0.257l0,0l0,0c-0.059-0.117-0.14-0.227-0.262-0.309 c-0.099-0.099-0.228-0.175-0.356-0.222c-0.257-0.181-0.548-0.297-0.875-0.31c-0.158,0-0.303-0.006-0.461-0.023 c0.11,0.023,0.245,0.059,0.373,0.082c-0.321-0.088-0.601-0.122-0.922-0.146c-0.198-0.018-0.403-0.053-0.601-0.094 c0.129,0.035,0.251,0.064,0.379,0.094c-0.426-0.105-0.957-0.21-1.406-0.193c-0.251,0.006-0.234,0.006,0.047,0 c-0.041-0.011-0.082-0.017-0.122-0.017c-0.158-0.023-0.298,0-0.449,0.017c-0.134,0.018-0.239,0.065-0.356,0.117 c-0.35,0-0.624,0.292-0.566,0.636c0,0.035-0.011,0.076-0.011,0.111c0-0.012,0.041,0.566,0.087,0.566 c0.006,0.023,0.006,0.041,0.017,0.058c0.059,0.18,0.152,0.327,0.274,0.473c0.023,0.029,0.041,0.058,0.058,0.07 c-0.169-0.274-0.152-0.239,0.076,0.111c0.105,0.105,0.234,0.216,0.356,0.31c0.104,0.082,0.204,0.158,0.321,0.222 c0.198,0.122,0.408,0.257,0.63,0.321c0.233,0.076,0.478,0.128,0.717,0.169c0.134,0.035,0.262,0.047,0.403,0.065 c0.14,0.017,0.262,0.017,0.408,0.011c0.268-0.011,0.449-0.07,0.717-0.157c-0.128,0.041-0.262,0.081-0.385,0.123 c0.239-0.065,0.49-0.093,0.729-0.164c0.31-0.093,0.555-0.204,0.776-0.443c0.122-0.134,0.198-0.274,0.257-0.431 C724.156,767.732,724.203,767.633,724.237,767.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC066"
    },
    d: "M723.608,762.878c-0.128-0.129-0.286-0.146-0.455-0.076c-0.017,0.006-0.047,0.017-0.07,0.023 c-0.053,0-0.105-0.023-0.175-0.006c-0.058,0.012-0.111,0.041-0.175,0.059c-0.017,0.006-0.158,0.058-0.059,0.023 c0.093-0.035-0.006,0-0.029,0c-0.093,0.035-0.175,0.059-0.256,0.093c-0.041,0.006-0.07,0.012-0.099,0.029h-0.018 c-0.047,0.011-0.099,0-0.146,0.017c-0.111,0.035-0.198,0.076-0.297,0.134c-0.146,0.076-0.298,0.146-0.455,0.204 c-0.151,0.07-0.28,0.134-0.42,0.21c-0.058,0.023-0.104,0.047-0.152,0.093c-0.011,0-0.005,0-0.011,0 c-0.012,0.006-0.029,0.012-0.047,0.024c-0.035,0.005-0.065,0.017-0.094,0.035c-0.023,0.006-0.186,0.065-0.035,0.012 c-0.146,0.047-0.263,0.117-0.35,0.216c-0.012,0.012-0.017,0.017-0.029,0.029c-0.047,0.047,0.012,0-0.035,0.017 c-0.035,0.012-0.07,0.041-0.111,0.065c-0.012,0.005-0.017,0.005-0.017,0.017c-0.012,0-0.012-0.012-0.035,0 c-0.262,0.076-0.356,0.479-0.053,0.572c0.076,0.023,0.146,0.064,0.228,0.099c0.029,0.006,0.064,0.017,0.093,0.035 c-0.064-0.029-0.011,0.006,0.023,0.018c0.099,0.087,0.216,0.146,0.333,0.163c0.391,0.023,0.805,0.076,1.184-0.035 c0.409-0.105,0.998-0.263,1.255-0.636c0.035-0.035,0.07-0.07,0.093-0.082c0.088-0.093,0.164-0.204,0.245-0.303 c0.041-0.059,0.088-0.122,0.128-0.181c0.07-0.117,0.099-0.222,0.105-0.339c0.023-0.029,0.035-0.058,0.053-0.093 C723.8,763.175,723.724,762.965,723.608,762.878z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M726.279,746.075c0.076-0.198-0.041-0.455-0.245-0.525c-0.28-0.088-0.578-0.064-0.869-0.017 c-0.409-0.07-0.782,0.029-1.184,0.157c-0.193,0.018-0.391,0.053-0.584,0.134c-0.186,0.076-0.367,0.175-0.548,0.268 c-0.373,0.181-0.712,0.397-1.062,0.636c-0.642,0.443-1.202,1.038-1.587,1.727c-0.385,0.706-0.66,1.464-0.904,2.234 c-0.117,0.373-0.24,0.753-0.362,1.138c-0.14,0.414-0.297,0.887-0.239,1.33c0.053,0.461,0.578,0.537,0.904,0.321 c0.332-0.204,0.572-0.636,0.781-0.98c0.21-0.35,0.443-0.694,0.671-1.044c0.403-0.613,0.788-1.418,1.214-1.902 c-0.047,0.059,0.093-0.082,0.111-0.099c0.076-0.076,0.152-0.134,0.228-0.198c0.14-0.116,0.28-0.216,0.426-0.315 c0.064-0.052,0.134-0.094,0.204-0.14c0.011-0.017,0.011-0.017,0.017-0.017c0.011-0.011,0.023-0.017,0.059-0.041 c0.216-0.129,0.42-0.257,0.63-0.403c0.07-0.041,0.134-0.088,0.198-0.128c0.076-0.053,0.076-0.053,0.012-0.012 c0.041-0.023,0.082-0.047,0.116-0.075c0.076-0.047,0.152-0.088,0.228-0.14c0.228-0.146,0.327-0.262,0.508-0.449 c0.041-0.041,0.21-0.157,0.332-0.256c0.198-0.164,0.321-0.35,0.42-0.554C725.965,746.53,726.163,746.331,726.279,746.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M724.034,749.517c-0.129-0.088-0.263-0.164-0.397-0.158c-0.326,0.011-0.688,0.011-0.974,0.186 c-0.269,0.164-0.584,0.379-0.7,0.689c-0.035,0.047-0.065,0.099-0.094,0.157c-0.005,0.023,0.012,0.041,0.012,0.065 c-0.082,0.152-0.152,0.292-0.117,0.455c0.017,0.116,0.099,0.174,0.204,0.204c0.075,0.012,0.128,0.012,0.204-0.011 c0.128-0.035-0.07,0.017,0.041-0.006c0.023-0.012,0.053-0.012,0.081-0.029c0.076,0.012,0.152,0,0.222,0 c0.17,0.012,0.345-0.011,0.508-0.041c0.076-0.006,0.158-0.017,0.228-0.023c0.087-0.018,0.181-0.059,0.274-0.093 c0.058-0.012,0.11-0.029,0.169-0.047c0.128-0.035,0.24-0.11,0.35-0.192c0.017-0.017,0.041-0.023,0.07-0.035 c0.006,0,0.035-0.006,0.047-0.012c0.035-0.012,0.07-0.017,0.099-0.029c0.198-0.087,0.385-0.274,0.379-0.496 C724.629,749.773,724.319,749.61,724.034,749.517z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M733.608,750.334c0.011-0.181-0.017-0.373-0.099-0.531c-0.065-0.134-0.146-0.274-0.257-0.373 c-0.099-0.134-0.251-0.228-0.391-0.327c-0.134-0.14-0.292-0.257-0.473-0.332c-0.105-0.041-0.263-0.058-0.391-0.082 c-0.099-0.023-0.181-0.035-0.274-0.041c-0.52-0.023-1.097,0.123-1.412,0.572c0.07-0.064,0.128-0.134,0.193-0.204 c-0.17,0.157-0.333,0.321-0.391,0.56c0.082-0.122,0.17-0.239,0.251-0.362c-0.157,0.157-0.28,0.332-0.332,0.548 c-0.041,0.181-0.059,0.414,0.099,0.554c0.023,0.023,0.041,0.041,0.064,0.065c0.047,0.053,0.076,0.076,0.111,0.111 c0.041,0.041,0.081,0.082,0.122,0.122c0.192,0.228,0.502,0.373,0.781,0.449c0.076,0.023,0.152,0.053,0.222,0.076 c0.128,0.047,0.269,0.082,0.397,0.105c0.053,0,0.105-0.006,0.146-0.006c0.017,0,0.023,0,0.035,0 c0.263,0.065,0.537,0.105,0.793,0.059c0.029,0,0.052,0.017,0.082,0.017c0,0,0.012,0,0.017,0c-0.017,0-0.017,0,0.018,0 c0.175-0.011,0.344-0.035,0.484-0.157c0.128-0.129,0.198-0.257,0.222-0.444c0.023-0.081,0.023-0.157,0.023-0.256 C733.648,750.415,733.619,750.375,733.608,750.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M733.018,751.302c-0.018-0.006-0.117,0.011-0.117,0.011 C732.931,751.314,733.07,751.314,733.018,751.302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M730.585,750.754c-0.058-0.041-0.099-0.088-0.157-0.14c-0.006-0.017-0.041-0.023-0.047-0.041 C730.445,750.631,730.515,750.695,730.585,750.754z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M727.686,756.191c-0.029-0.099-0.088-0.175-0.14-0.262c-0.081-0.117-0.204-0.193-0.338-0.228 c-0.064-0.011-0.128-0.023-0.198-0.029c-0.064,0-0.134,0-0.192,0.006c-0.088,0.012-0.187,0.035-0.274,0.064 c-0.023,0.018-0.047,0.035-0.07,0.052c-0.035,0.023-0.064,0.065-0.088,0.105c-0.023,0.059-0.041,0.146-0.029,0.222 c0.018,0.053,0.041,0.111,0.082,0.164c0.047,0.076,0.14,0.099,0.222,0.117c-0.017,0-0.041-0.012-0.053-0.017 c0.035,0.017,0.064,0.023,0.088,0.035c0.053,0.029,0.093,0.064,0.134,0.099c0.018,0.018,0.035,0.041,0.058,0.047 c0.017,0.018,0.041,0.029,0.059,0.041c0.047,0.017,0.087,0.053,0.122,0.076c-0.018-0.018-0.035-0.023-0.052-0.047l0,0 c0.035,0.041,0.07,0.076,0.116,0.087c0.041,0.035,0.093,0.053,0.146,0.053c0.041,0,0.07,0,0.111,0 c0.053-0.017,0.105-0.035,0.146-0.064c0.041-0.018,0.064-0.047,0.087-0.07c0.035-0.041,0.065-0.081,0.088-0.134 c0-0.029,0.006-0.065,0.011-0.099C727.732,756.331,727.715,756.262,727.686,756.191z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M717.208,749.569c0.035-0.14,0.006-0.315-0.093-0.425c-0.088-0.088-0.204-0.158-0.333-0.164 c-0.065-0.017-0.14,0-0.204,0.006c-0.111,0-0.216,0.029-0.315,0.076c-0.035,0.017-0.058,0.035-0.088,0.041 c-0.041,0.029-0.07,0.041-0.105,0.07c-0.081,0.059-0.14,0.122-0.204,0.187c-0.047,0.053-0.094,0.11-0.128,0.169 c-0.059,0.099-0.117,0.204-0.158,0.303c-0.011,0.035-0.035,0.07-0.041,0.105c-0.018,0.058-0.035,0.111-0.041,0.169 c-0.005,0.011,0.006,0.017,0.006,0.035c0,0.052-0.017,0.117-0.035,0.17c0,0.029-0.006,0.064-0.006,0.099 c-0.006,0.146,0.041,0.262,0.134,0.379c-0.017-0.023-0.029-0.047-0.041-0.064c0-0.012,0-0.017,0-0.029c0,0.012,0,0.012,0,0.012 c-0.017-0.035-0.035-0.076-0.052-0.111c0.012,0.053,0.035,0.088,0.041,0.128v0.023c-0.012,0.105,0.07,0.234,0.169,0.263 c0.105,0.035,0.245,0.011,0.304-0.099c0,0,0.005,0,0.005-0.006c0.023-0.006,0.041-0.018,0.053-0.023 c0.129-0.053,0.234-0.134,0.344-0.234c0.023-0.017,0.065-0.023,0.088-0.053c0.029-0.023,0.052-0.058,0.076-0.082 c0.099-0.087,0.186-0.163,0.274-0.274c-0.041,0.041-0.076,0.094-0.117,0.134c0.029-0.035,0.058-0.059,0.081-0.093 c0.012-0.006,0.035-0.017,0.047-0.029c0.029-0.047,0.07-0.087,0.111-0.128c0-0.006,0-0.017,0.017-0.023 c0.012-0.035,0.029-0.064,0.053-0.099c0.029-0.058,0.065-0.11,0.082-0.175c0.035-0.059,0.041-0.122,0.052-0.181 c-0.012,0.047-0.018,0.099-0.029,0.146C717.172,749.721,717.19,749.645,717.208,749.569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M722.516,758.105c-0.017-0.035-0.041-0.059-0.058-0.094c-0.059-0.175-0.146-0.332-0.298-0.431 c-0.164-0.111-0.42-0.216-0.613-0.222c-0.157-0.012-0.309,0-0.455,0.023c-0.181,0.023-0.315,0.134-0.444,0.262 c-0.017,0.029-0.035,0.041-0.058,0.07c-0.012,0.018-0.006,0.029-0.012,0.047c-0.029,0.041-0.07,0.07-0.087,0.117 c0,0.011-0.006,0.011-0.006,0.023c0.023-0.041,0.053-0.07,0.082-0.117c-0.047,0.059-0.065,0.128-0.082,0.193 c-0.029,0.041-0.041,0.081-0.059,0.134c0,0.018-0.005,0.018-0.005,0.023c0.005-0.005,0.005-0.005,0.005-0.005 c-0.005,0.035-0.023,0.058-0.017,0.099c0.006,0.035,0.035,0.058,0.052,0.093c0-0.012-0.006-0.012-0.006-0.017 c0.029,0.099,0.053,0.163,0.122,0.245c0.006,0.011,0.006,0.011,0.006,0.011c0.023,0.035,0.029,0.065,0.047,0.088 c0.076,0.105,0.187,0.157,0.303,0.21c0-0.005-0.012-0.005-0.023-0.005c0.011,0,0.023,0.005,0.029,0.005 c0.017,0.006,0.023,0.023,0.041,0.035c0.041,0.006,0.082,0.029,0.116,0.047c-0.017-0.006-0.041-0.017-0.064-0.029 c0.087,0.047,0.146,0.07,0.239,0.105c0.041,0.017,0.065,0.035,0.099,0.041c0.17,0.059,0.339,0.053,0.508,0.018 c0.122,0.005,0.251-0.018,0.356-0.059c0.122-0.059,0.222-0.158,0.292-0.274C722.627,758.549,722.633,758.292,722.516,758.105z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M720.778,768.759c0-0.082,0.012-0.175,0-0.257c-0.047-0.146-0.11-0.28-0.186-0.432 c-0.122-0.216-0.234-0.455-0.403-0.636c-0.117-0.14-0.234-0.268-0.361-0.403c-0.053-0.064-0.117-0.14-0.181-0.204 c-0.035-0.035-0.064-0.064-0.099-0.099c-0.134-0.128-0.263-0.216-0.438-0.298c0.07,0.041,0.14,0.07,0.204,0.111 c-0.105-0.088-0.233-0.17-0.361-0.228c-0.152-0.111-0.315-0.216-0.508-0.234c-0.21-0.023-0.461,0.029-0.589,0.198 c-0.111,0.152-0.169,0.35-0.158,0.537c-0.082-0.052-0.175-0.111-0.274-0.158c0,0,0,0,0-0.006 c-0.076-0.041-0.152-0.093-0.228-0.122c-0.081-0.059-0.169-0.076-0.268-0.093c0.035-0.006-0.128-0.041-0.186-0.047 c-0.088-0.035-0.193-0.047-0.292-0.018c-0.222,0.065-0.245,0.082-0.087,0.023c-0.187,0.035-0.373,0.181-0.432,0.368 c-0.011,0.023-0.017,0.029-0.041,0.07c-0.035,0.093-0.053,0.192-0.035,0.286c0,0.047,0.017,0.274,0.023,0.146 c-0.011,0.14,0.012,0.292,0.065,0.455c0.005,0.018,0.017,0.035,0.017,0.053c0,0.023,0,0.059,0.011,0.082 c0.018,0.128,0.082,0.268,0.128,0.391c0.018,0.041,0.035,0.093,0.047,0.14c0.006,0.052,0.041,0.099,0.053,0.14 c0.006,0.017,0.012,0.047,0.023,0.059v-0.006c0.023,0.076,0.041,0.157,0.082,0.233c0.059,0.117,0.117,0.24,0.175,0.356 c0.047,0.111,0.099,0.222,0.146,0.333c0.029,0.058,0.052,0.117,0.07,0.169c0.076,0.163,0.175,0.268,0.28,0.379v0.006 c-0.006-0.006-0.017-0.012-0.035-0.024c0.041,0.041,0.075,0.082,0.099,0.134c0.017,0.017,0.029,0.041,0.041,0.064 c0.117,0.193,0.222,0.373,0.426,0.508c0.052,0.035,0.116,0.023,0.169,0.058c0.129,0.122,0.268,0.256,0.455,0.338 c0.473,0.21,0.968-0.116,1.161-0.536c0.076-0.169,0.076-0.333,0.076-0.508c0.064-0.192,0.076-0.397,0.041-0.607 c0.094,0.052,0.181,0.076,0.274,0.1c0.094,0.052,0.175,0.117,0.274,0.151c0.222,0.082,0.479,0.041,0.66-0.116 c0.186-0.158,0.245-0.379,0.222-0.624C720.83,768.916,720.801,768.834,720.778,768.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M715.93,766.763L715.93,766.763C715.976,766.675,715.988,766.652,715.93,766.763z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFF59"
    },
    d: "M728.047,770.182c0-0.035-0.005-0.058-0.005-0.093c-0.047-0.234-0.17-0.437-0.368-0.572 c-0.035-0.023-0.064-0.053-0.11-0.07c-0.082-0.047-0.181-0.111-0.268-0.146c-0.105-0.041-0.216-0.058-0.321-0.065 c-0.14-0.011-0.28,0-0.42,0.006c-0.064,0.017-0.122,0.041-0.18,0.058c-0.058,0.035-0.111,0.064-0.158,0.099 c-0.047,0.041-0.088,0.093-0.128,0.14c-0.058,0.076-0.093,0.158-0.105,0.251c-0.023,0.064-0.035,0.122-0.023,0.192 c0,0.065,0.012,0.128,0.041,0.187c0.005,0.058,0.035,0.128,0.076,0.169c0.041,0.082,0.11,0.158,0.192,0.204 c0.064,0.041,0.128,0.093,0.186,0.134c0.065,0.053,0.134,0.082,0.198,0.123v-0.006c0,0.006,0.006,0.006,0.018,0.017 c0.017,0.006,0.023,0.017,0.047,0.023c0.011,0.012,0.011,0.012,0.017,0.012c0.012,0.005,0.012,0.005,0.017,0.011c0,0,0,0,0.006,0 c0.023,0.012,0.052,0.017,0.076,0.035c-0.023-0.006-0.029-0.018-0.053-0.023c0.122,0.064,0.234,0.128,0.379,0.14 c0.076,0,0.175,0,0.245-0.017c0.047-0.006,0.105-0.006,0.152-0.018c0.053-0.023,0.105-0.029,0.158-0.058 c0.076-0.029,0.14-0.07,0.181-0.14c0.047-0.035,0.076-0.075,0.094-0.122c0.041-0.07,0.064-0.14,0.064-0.227 C728.077,770.357,728.053,770.264,728.047,770.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18FFFF"
    },
    d: "M287.571,464.139c11.231-1.75,21.855-1.05,30.35,1.528c-6.855-6.949-18.588-10.56-31.114-8.611 c-12.252,1.92-22.129,8.676-26.686,17.118C267.32,469.46,276.842,465.813,287.571,464.139z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036974294184298508610000006565753513036373183_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.2317,
    y1: 399.1468,
    x2: 385.1715,
    y2: 399.1468
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_00000036974294184298508610000006565753513036373183_)"
    },
    d: "M323.108,427.01 c12.45-9.306,34.813-23.6,33.57-41.773c-1.295-18.967-21.167-31.201-36.867-36.878c-51.668-18.693-113.174,6.336-136.598,55.624 c-4.241,8.933-7.648,18.495-9.667,28.273c10.175,7.561,21.674,13.413,33.64,17.479c14.166,4.807,29.002,7.013,43.944,6.254 c13.302-0.694,26.395-3.88,38.617-9.148C301.667,441.7,312.729,434.77,323.108,427.01z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088119830200910148940000003145145542716150675_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.3252,
    y1: 426.2571,
    x2: 409.8672,
    y2: 426.2571
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "url(#SVGID_00000088119830200910148940000003145145542716150675_)"
    },
    d: "M241.019,476.409 c-7.27-23.833-12.176-48.389-14.556-73.191c-0.595-6.231-1.027-12.485-1.301-18.734c-0.228-5.222-0.589-10.438-0.659-15.665 c-0.029-2.223-0.006-4.475,0.064-6.721c-2.812,0-5.654,0-8.495,0.011c-17.952,13.851-31.435,34.434-37.969,55.951 c2.491,9.795,5.42,19.474,8.646,29.002c4.487,13.238,9.58,26.254,15.03,39.131c12.969,1.616,28.786,3.121,43.862,4.224 C244.012,485.778,242.449,481.111,241.019,476.409z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131343751670766078170000001221813014855137167_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.332,
    y1: 426.756,
    x2: 409.8466,
    y2: 426.756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "url(#SVGID_00000131343751670766078170000001221813014855137167_)"
    },
    d: "M256.206,476.216 c-5.852-20.286-10.321-40.969-13.43-61.85c-1.54-10.309-2.649-20.676-3.886-31.026c-0.846-7.025-1.4-14.131-1.044-21.202 c-3.635-0.017-7.381-0.035-11.208-0.041c-0.111,3.95-0.023,7.882,0.122,11.733c0.916,23.786,3.238,47.368,8.203,70.665 c3.326,15.618,7.672,31.021,12.958,46.091c4.434,0.315,8.786,0.59,12.976,0.829C259.252,486.368,257.676,481.309,256.206,476.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063615063571045251020000004631530761551862422_",
    gradientUnits: "userSpaceOnUse",
    x1: -2614.0984,
    y1: 814.5796,
    x2: -2579.2397,
    y2: 884.9305,
    gradientTransform: "matrix(-0.9777 0.2101 0.2101 0.9777 -2564.0911 271.0099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    style: {
      stopColor: "#A4D6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#87BCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000063615063571045251020000004631530761551862422_)"
    },
    d: "M184.549,547.103 l-1.179-1.004c0.017,0.023,0.029,0.041,0.047,0.076c2.934,6.517-0.578,13.098-7.865,13.693 c-15.42,1.266-28.588-13.571-37.608-24.177c-6.464-7.602-17.316-17.946-19.247-28.687c-3.664-0.928-6.453-1.021-6.388,0.869 c0.677,21.26,73.232,87.351,82.438,86.668C203.948,593.864,190.028,552.767,184.549,547.103z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044156056083340122240000003440849086655461288_",
    gradientUnits: "userSpaceOnUse",
    x1: 73.2427,
    y1: 219.8367,
    x2: 108.1028,
    y2: 290.1906,
    gradientTransform: "matrix(0.9777 0.2101 -0.2101 0.9777 420.3119 271.0099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    style: {
      stopColor: "#A4D6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#87BCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000044156056083340122240000003440849086655461288_)"
    },
    d: "M491.841,489.746 c-3.238,17.783-21.878,33.471-34.766,43.477c-7.41,5.764-15.513,12.013-25.35,12.164c-5.554,0.087-9.953-1.628-13.191-4.627 c-5.694,14.055-11.453,36.441-4.679,36.948c9.206,0.683,81.756-65.408,82.433-86.668 C496.339,489.495,494.501,489.273,491.841,489.746z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096758707204480536550000012311513170678836375_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.3005,
    y1: 571.0873,
    x2: 347.075,
    y2: 571.0873
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "url(#SVGID_00000096758707204480536550000012311513170678836375_)"
    },
    d: "M312.588,601.029 c-10.315-13.752-23.477-15.169-34.585-11.779c-15.059,4.603-31.155,17.66-33.711,33.979c-3.36-7.923-5.63-16.692-6.581-25.262 c-1.295-11.75,0.671-23.757,3.139-35.221c2.894-13.471,8.174-26.027,13.395-38.553c0,0,43.693,22.281,92.829-5.245 C347.075,518.946,313.872,565.376,312.588,601.029z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114756195958187848710000013747382331480000184_",
    gradientUnits: "userSpaceOnUse",
    x1: 252.5156,
    y1: 632.2343,
    x2: 303.1744,
    y2: 632.2343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000114756195958187848710000013747382331480000184_)"
    },
    d: "M296.469,638.147 c2.433-5.502,6.593-12.217,6.703-18.384c0.158-8.401-6.277-16.47-14.288-18.786c-19.556-5.654-45.105,24.247-33.424,42.176 c4.673,7.182,11.29,16.826,19.585,20.262C287.647,668.637,292.927,646.157,296.469,638.147z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062885463019921062270000013971971811958019212_",
    gradientUnits: "userSpaceOnUse",
    x1: -2614.2324,
    y1: 814.6495,
    x2: -2579.3755,
    y2: 884.9974,
    gradientTransform: "matrix(-0.9777 0.2101 0.2101 0.9777 -2564.0911 271.0099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    style: {
      stopColor: "#A4D6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#87BCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000062885463019921062270000013971971811958019212_)"
    },
    d: "M191.83,562.213 c-0.303,0.875-0.654,1.739-1.085,2.573c-5.548,10.542-16.954,8.681-25.21,2.753c-21.418-15.356-39.948-36.114-53.145-59.025 c1.984,21.861,73.232,86.703,82.357,86.026C200.815,594.098,196.83,576.064,191.83,562.213z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133499867613056179530000006612971018688569003_",
    gradientUnits: "userSpaceOnUse",
    x1: 69.1209,
    y1: 221.8787,
    x2: 103.981,
    y2: 292.2327,
    gradientTransform: "matrix(0.9777 0.2101 -0.2101 0.9777 420.3119 271.0099)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    style: {
      stopColor: "#A4D6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#87BCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "url(#SVGID_00000133499867613056179530000006612971018688569003_)"
    },
    d: "M452.786,543.52 c-8.641,6.879-28.186,19.773-40.163,15.554c-2.363,9.795-2.917,18.326,1.231,18.635c7.655,0.566,59.049-45,76.575-72.602 C479.332,519.337,466.736,532.412,452.786,543.52z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176735522423258318890000003856037338123201441_",
    gradientUnits: "userSpaceOnUse",
    x1: 450.1373,
    y1: 504.0364,
    x2: 462.9215,
    y2: 529.8373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "url(#SVGID_00000176735522423258318890000003856037338123201441_)"
    },
    d: "M465.546,496.444 c0,0-26.383,22.042-36.849,32.234c0,0-3.576,16.575,16.196,4.947c19.761-11.639,37.375-33.944,37.806-37.182 c0.187-1.377-10.082,2.375-10.082,2.375L465.546,496.444z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007414311568011258530000015147318990846931601_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.5757,
    y1: 507.1967,
    x2: 170.5074,
    y2: 561.5497
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "url(#SVGID_00000007414311568011258530000015147318990846931601_)"
    },
    d: "M144.474,514.215 c0,0,34.941,29.037,35.373,30.962c0.431,1.937-7.946,6.354-18.792,2.352c-8.314-3.063-31.464-33.314-31.464-33.314l7.532,2.182 L144.474,514.215z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172433678974297518430000006990745227812719539_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.6979,
    y1: 664.702,
    x2: 279.919,
    y2: 591.0334,
    gradientTransform: "matrix(0.9951 0.0984 -0.0984 0.9951 70.6767 -70.2672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EEFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A3C9E3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172433678974297518430000006990745227812719539_)"
    },
    d: "M319.24,586.63 c-1.826,18.454-15.344,32.228-30.186,30.758c-14.854-1.47-25.403-17.613-23.582-36.067c1.826-18.453,15.338-32.222,30.186-30.752 C310.506,552.033,321.06,568.182,319.24,586.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132090198253990521990000010033819729992383404_",
    gradientUnits: "userSpaceOnUse",
    x1: 289.1375,
    y1: 660.4846,
    x2: 280.5215,
    y2: 595.5775,
    gradientTransform: "matrix(0.9951 0.0984 -0.0984 0.9951 70.6767 -70.2672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132090198253990521990000010033819729992383404_)"
    },
    d: "M316.037,586.315 c-1.611,16.266-13.513,28.389-26.593,27.094c-13.081-1.283-22.38-15.519-20.77-31.773c1.605-16.26,13.512-28.39,26.593-27.101 C308.341,555.836,317.641,570.055,316.037,586.315z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054981705432975093920000016460427772879708051_",
    gradientUnits: "userSpaceOnUse",
    x1: 283.6803,
    y1: 628.7954,
    x2: 278.366,
    y2: 588.7614,
    gradientTransform: "matrix(0.9951 0.0984 -0.0984 0.9951 70.6767 -70.2672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_00000054981705432975093920000016460427772879708051_)"
    },
    d: "M296.795,560.136 c2.292-3.716,3.699-7.911,4.58-12.228c-1.733-1.208-3.711-2.001-5.858-2.217c-8.063-0.793-15.408,6.686-16.394,16.709 c-0.134,1.307-0.14,2.585-0.053,3.828C284.315,573.018,293.638,565.276,296.795,560.136z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078003148134648673660000008053168279023352483_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.7417,
    y1: 630.8563,
    x2: 276.0635,
    y2: 588.0806,
    gradientTransform: "matrix(0.9951 0.0984 -0.0984 0.9951 70.6767 -70.2672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_00000078003148134648673660000008053168279023352483_)"
    },
    d: "M285.027,558.602 c3.022-4.417,6.599-8.337,10.7-11.774c0.636-0.536,1.29-1.08,1.955-1.61c-0.589-0.14-1.184-0.257-1.797-0.321 c-8.617-0.846-16.464,7.146-17.52,17.852c-0.268,2.742-0.07,5.391,0.519,7.83C280.442,566.367,282.466,562.33,285.027,558.602z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083050108052842922970000009203596849282439064_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.4441,
    y1: 660.1871,
    x2: 282.8271,
    y2: 595.2714,
    gradientTransform: "matrix(0.9951 0.0984 -0.0984 0.9951 70.6767 -70.2672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_00000083050108052842922970000009203596849282439064_)"
    },
    d: "M291.427,591.279 c3.204-6.05,6.984-11.808,11.126-17.257c2.59-3.402,5.28-6.663,8.296-9.604c-0.42-0.624-0.846-1.237-1.307-1.808 c-2.771,1.844-5.303,4.242-7.479,6.161c-4.994,4.4-9.417,9.376-13.028,14.965c-5,7.719-8.436,16.243-10.344,25.14 c1.429,1.167,2.981,2.112,4.62,2.859C285.255,604.687,287.944,597.849,291.427,591.279z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152958189023851418750000001027405017367210120_",
    gradientUnits: "userSpaceOnUse",
    x1: 302.6507,
    y1: 658.6942,
    x2: 294.0351,
    y2: 593.7901,
    gradientTransform: "matrix(0.9951 0.0984 -0.0984 0.9951 70.6767 -70.2672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0D0027"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1445,
    style: {
      stopColor: "#1C092D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#2B1232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6011,
    style: {
      stopColor: "#331735"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#361936"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_00000152958189023851418750000001027405017367210120_)"
    },
    d: "M312.379,582.832 c-3.512,4.813-6.744,9.854-9.539,15.116c-2.515,4.75-4.563,9.708-6.15,14.813c9.977-2.806,18.045-13.261,19.347-26.446 c0.274-2.777,0.192-5.484-0.134-8.081C314.677,579.751,313.499,581.297,312.379,582.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#18FFFF"
    },
    d: "M303.137,582.283c0,3.599-4.895,13.215-10.945,13.215c-6.045,0-10.952-9.615-10.952-13.215 c0-3.606,4.907-6.523,10.952-6.523C298.242,575.761,303.137,578.677,303.137,582.283z"
  }), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000167364333633815508650000010428277511440698000_",
    filterUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58,
    id: "SVGID_00000091727017833314609600000018132113724015666832_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000167364333633815508650000010428277511440698000_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000060722458309084556960000015877685807890533819_",
    filterUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend28 || (_feBlend28 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58,
    id: "SVGID_00000091727017833314609600000018132113724015666832_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000060722458309084556960000015877685807890533819_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000155134272377911353260000011526367379552420028_",
    cx: 557.5344,
    cy: 698.2708,
    r: 19.5939,
    gradientTransform: "matrix(1.6271 -0.1669 0.176 1.7163 -737.8709 -520.8776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1038,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3131,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#070707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000091727017833314609600000018132113724015666832_)",
      fill: "url(#SVGID_00000155134272377911353260000011526367379552420028_)"
    },
    d: " M324.07,581.239c1.914,18.576-10.822,35.093-28.431,36.902c-17.602,1.803-33.424-11.785-35.333-30.361 c-1.902-18.57,10.828-35.099,28.437-36.896C306.352,549.069,322.168,562.669,324.07,581.239z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000043432295743570836700000018346184350443218067_",
    filterUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend29 || (_feBlend29 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58,
    id: "SVGID_00000001635600463568649090000004325595776491284106_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000043432295743570836700000018346184350443218067_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000078743808898522437020000012568452028957456319_",
    filterUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend30 || (_feBlend30 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 260.119,
    y: 550.721,
    width: 64.142,
    height: 67.58,
    id: "SVGID_00000001635600463568649090000004325595776491284106_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000078743808898522437020000012568452028957456319_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000045583184311931894660000015079754623406979516_",
    cx: 557.5344,
    cy: 698.2708,
    r: 19.5939,
    gradientTransform: "matrix(1.6271 -0.1669 0.176 1.7163 -737.8709 -520.8776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1895,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3229,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CDCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9163,
    style: {
      stopColor: "#363636"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000001635600463568649090000004325595776491284106_)",
      fill: "url(#SVGID_00000045583184311931894660000015079754623406979516_)"
    },
    d: " M324.07,581.239c1.914,18.576-10.822,35.093-28.431,36.902c-17.602,1.803-33.424-11.785-35.333-30.361 c-1.902-18.57,10.828-35.099,28.437-36.896C306.352,549.069,322.168,562.669,324.07,581.239z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000106117697138361029510000001330665533914129562_",
    cx: 557.5344,
    cy: 698.2708,
    r: 19.5939,
    gradientTransform: "matrix(1.6271 -0.1669 0.176 1.7163 -737.8709 -520.8776)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    style: {
      stopColor: "#01CEFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#03C5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4975,
    style: {
      stopColor: "#06B6E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#0BA0CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    style: {
      stopColor: "#1284B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8383,
    style: {
      stopColor: "#1A628E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9392,
    style: {
      stopColor: "#233A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A1E49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000106117697138361029510000001330665533914129562_)"
    },
    d: "M324.07,581.239 c1.914,18.576-10.822,35.093-28.431,36.902c-17.602,1.803-33.424-11.785-35.333-30.361c-1.902-18.57,10.828-35.099,28.437-36.896 C306.352,549.069,322.168,562.669,324.07,581.239z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.41,
      fill: "#3C4B6D"
    },
    d: "M230.897,710.818c0,0,4.364,3.396,7.375,1.681c3.01-1.71,9.883-12.667,9.236-15.683 c-0.648-3.005-6.225-7.509-6.225-7.509s7.082,3.74,12.666,1.651c5.584-2.083,11.493-22.643-9.93-36.633 c0,0,22.777,1.849,29.346,40.542c0,0-7.602,5.659-20.274,3.617l-12.631,21.686C240.459,720.17,233.067,712.86,230.897,710.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.41,
      fill: "#3C4B6D"
    },
    d: "M345.074,659.482c0,0-22.357,22.375-17.235,31.5c3.408,6.079,9.644,6.639,18.396,2.042 l0.841-0.432l-10.438,10.187l6.021,15.951l-2.812,3.746l-8.168-20.087c0,0-9.218,2.823-19.096-3.413 C312.582,698.975,326.655,669.599,345.074,659.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M420.214,536.846c-6.832,0.023-13.804-1.109-20.344-2.818c-8.746-2.281-15.858-6.704-22.853-12.223 c-16.354-12.894-28.868,21.313-23.53,32.917c1.896,4.113,4.154,0.169,6.4-1.698c3.542-2.923,7.281-5.023,12.036-4.568 c11.814,1.132,21.843,9.445,34.241,9.486c2.287,0.012,4.609-0.262,6.931-0.747C414.98,549.932,417.728,542.254,420.214,536.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.41,
      fill: "#3C4B6D"
    },
    d: "M411.124,550.043c-3.273,1.202-6.867,0.356-10.146-0.385 c-2.363-0.537-4.644-1.108-6.902-2.007c-5.438-2.159-10.689-4.924-15.391-8.407c-4.521-3.355-9.662-7.714-10.98-13.483 c-0.554-2.445-0.309-4.679,0.496-6.674c-11.645,2.019-19.037,26.243-14.714,35.636c1.896,4.113,4.154,0.169,6.4-1.698 c3.542-2.923,7.281-5.023,12.036-4.568c11.814,1.132,21.843,9.445,34.241,9.486c2.287,0.012,4.609-0.262,6.931-0.747 c0.951-3.675,2.129-7.45,3.378-10.985C414.968,547.902,413.166,549.302,411.124,550.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M244.257,537.4c-0.42-0.31-0.852-0.607-1.307-0.887c-6.517-4.061-12.345-0.642-17.754,3.845 c-5.297,4.381-9.644,8.722-16.464,10.508c-6.54,1.709-13.512,2.835-20.35,2.812c2.485,5.414,5.234,13.098,7.118,20.356 c2.322,0.479,4.65,0.753,6.931,0.747c12.275-0.053,22.229-8.185,33.892-9.44C238.907,554.71,241.749,545.119,244.257,537.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.41,
      fill: "#3C4B6D"
    },
    d: "M242.951,536.513c-1.074-0.665-2.124-1.114-3.157-1.412 c2.223,5.128,2.281,10.683-0.163,15.887c-4.376,9.288-15.245,14.795-25.035,15.997c-4.569,0.554-9.627,0.076-13.6-2.433 c-4.044-2.532-6.237-6.581-6.856-11.126c-1.925,0.158-3.844,0.262-5.758,0.251c2.485,5.414,5.234,13.098,7.118,20.356 c2.322,0.479,4.65,0.753,6.931,0.747c12.275-0.053,22.229-8.185,33.892-9.44c2.585-10.63,5.426-20.221,7.934-27.94 C243.837,537.091,243.405,536.793,242.951,536.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M234.608,818.665c-4.82-0.105-9.516-0.689-14.288-1.272c-3.903-0.473-6.913-1.365-8.973-4.201 c-1.599,1.149-2.421,2.491-1.476,4.002c3.168,5.076,40.746,2.159,40.746,2.159s0.017-0.391,0.041-1.062 C245.307,818.583,239.958,818.781,234.608,818.665z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M374.14,817.212c-4.329-0.058-8.658-0.204-12.97-0.536c-1.703-0.134-3.413-0.309-5.081-0.619 c0.251,0.841,0.402,1.348,0.402,1.348s34.253,4.446,37.421-0.624c0.076-0.122,0.099-0.239,0.158-0.367 C387.454,817.054,380.797,817.305,374.14,817.212z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131348461181892207060000012082096080765699458_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.3261,
    y1: 719.0579,
    x2: 264.8246,
    y2: 820.4183
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    style: {
      stopColor: "#A4D6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#87BCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "url(#SVGID_00000131348461181892207060000012082096080765699458_)"
    },
    d: "M245.401,800.777 c-0.671,2.947-2.106,7.614-5.799,7.888c-2.538,0.181-5.239-1.505-7.771-1.744c-2.287-0.216-4.726,0.665-6.779,1.557 c3.401,0.175,7.065,1.108,10.344,2.095c2.025,0.612,2.853,2.334,1.103,3.816c-1.558,1.336-4.446,2.135-6.406,2.509 c-6.004,1.173-12.223-0.31-17.917-2.217c-0.63-0.216-1.143-0.531-1.576-0.893c-1.085,1.009-1.517,2.153-0.729,3.407 c3.168,5.076,40.746,2.159,40.746,2.159s2.654-76.324,0.752-85.198c-0.402-1.879-2.73-5.047-6.132-8.874 c0.373,5.496,0.974,10.98,1.5,16.459c0.945,9.831,1.132,19.609,1.114,29.469C247.839,781.045,247.594,791.138,245.401,800.777z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167366575472375312270000010099293654072572039_",
    gradientUnits: "userSpaceOnUse",
    x1: -2838.0007,
    y1: 724.5253,
    x2: -2772.3533,
    y2: 811.5081,
    gradientTransform: "matrix(-1 0 0 1 -2437.0781 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D0FFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4415,
    style: {
      stopColor: "#A4D6EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7967,
    style: {
      stopColor: "#87BCDD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "url(#SVGID_00000167366575472375312270000010099293654072572039_)"
    },
    d: "M371.742,812.522 c-0.519-2.632,5.665-4.575,7.66-4.003c-4.031-1.149-7.725,2.451-11.651,1.406c-2.217-0.59-3.098-2.608-4.376-4.265 c-1.552-2.019-2.987-4.084-4.247-6.295c-5.035-8.763-7.76-18.699-9.813-28.53c-2.533-12.094-4.084-24.381-5.414-36.657 c-0.537-5.012-1.097-10.058-1.33-15.099c-4.113,4.959-7.118,9.224-7.625,11.604c-1.902,8.874,21.546,86.721,21.546,86.721 s34.253,4.446,37.421-0.624c0.59-0.939,0.595-1.844,0.228-2.69c-3.565,1.669-7.479,2.684-11.429,2.614 c-3.057-0.041-8.122-0.665-10.327-3.034C372.017,813.28,371.812,812.895,371.742,812.522z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093144638735076581530000003809937720040793234_",
    gradientUnits: "userSpaceOnUse",
    x1: 164.822,
    y1: 674.5073,
    x2: 251.7396,
    y2: 789.6731
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000093144638735076581530000003809937720040793234_)"
    },
    d: "M206.061,694.634 c-0.765,5.554,14.626,98.757,17.287,102.748c2.66,3.985,8.109-78.6,7.55-80.536C230.331,714.914,206.515,691.314,206.061,694.634z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114058309967307261650000004005124685711510410_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.5227,
    y1: 679.3785,
    x2: 405.9629,
    y2: 781.9866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000114058309967307261650000004005124685711510410_)"
    },
    d: "M372.308,692.644 c-3.162-0.823-20.28,19.486-20.951,24.201c-0.665,4.726,23.314,74.393,27.602,73.547 C383.248,789.552,376.783,693.806,372.308,692.644z"
  }), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000052094441248826962500000006889396313253360047_",
    filterUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432,
    id: "SVGID_00000037679412173544057360000000593257161861898401_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000052094441248826962500000006889396313253360047_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000051369349137559663590000008254622788122237848_",
    filterUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend31 || (_feBlend31 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432,
    id: "SVGID_00000037679412173544057360000000593257161861898401_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000051369349137559663590000008254622788122237848_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000002353039115315835840000001763485036741294464_",
    cx: 570.5816,
    cy: 402.6306,
    r: 53.2795,
    gradientTransform: "matrix(1.2357 -0.3684 0.2857 0.9583 -488.2797 240.9427)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1038,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3131,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#070707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000037679412173544057360000000593257161861898401_)",
      fill: "url(#SVGID_00000002353039115315835840000001763485036741294464_)"
    },
    d: " M397.658,396.958c8.407,28.197-14.259,59.842-50.618,70.682c-36.359,10.84-72.648-3.226-81.056-31.424 c-8.401-28.203,14.253-59.854,50.618-70.694C352.961,354.682,389.25,368.76,397.658,396.958z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000047019777446438325730000014057132032632088500_",
    filterUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend32 || (_feBlend32 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432,
    id: "SVGID_00000064314843587973716720000014722339415750471828_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000047019777446438325730000014057132032632088500_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000101806369390144955880000007078569730797079703_",
    filterUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend33 || (_feBlend33 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 264.234,
    y: 361.866,
    width: 135.176,
    height: 109.432,
    id: "SVGID_00000064314843587973716720000014722339415750471828_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000101806369390144955880000007078569730797079703_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000122698779299559620630000000309150222053625022_",
    cx: 570.5816,
    cy: 402.6306,
    r: 53.2795,
    gradientTransform: "matrix(1.2357 -0.3684 0.2857 0.9583 -488.2797 240.9427)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1895,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3229,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CDCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9163,
    style: {
      stopColor: "#363636"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000064314843587973716720000014722339415750471828_)",
      fill: "url(#SVGID_00000122698779299559620630000000309150222053625022_)"
    },
    d: " M397.658,396.958c8.407,28.197-14.259,59.842-50.618,70.682c-36.359,10.84-72.648-3.226-81.056-31.424 c-8.401-28.203,14.253-59.854,50.618-70.694C352.961,354.682,389.25,368.76,397.658,396.958z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000162350761624594618940000003818782727740392092_",
    cx: 570.5816,
    cy: 402.6306,
    r: 53.2795,
    gradientTransform: "matrix(1.2357 -0.3684 0.2857 0.9583 -488.2797 240.9427)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    style: {
      stopColor: "#01CEFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#03C5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4975,
    style: {
      stopColor: "#06B6E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#0BA0CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    style: {
      stopColor: "#1284B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8383,
    style: {
      stopColor: "#1A628E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9392,
    style: {
      stopColor: "#233A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A1E49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000162350761624594618940000003818782727740392092_)"
    },
    d: "M397.658,396.958 c8.407,28.197-14.259,59.842-50.618,70.682c-36.359,10.84-72.648-3.226-81.056-31.424c-8.401-28.203,14.253-59.854,50.618-70.694 C352.961,354.682,389.25,368.76,397.658,396.958z"
  })), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000120521002159013586230000001201619575265049757_",
    filterUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426,
    id: "SVGID_00000000942651463753728830000006201250372589679236_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000120521002159013586230000001201619575265049757_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000179636604253860966190000003367270257697988229_",
    filterUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend34 || (_feBlend34 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426,
    id: "SVGID_00000000942651463753728830000006201250372589679236_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000179636604253860966190000003367270257697988229_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000072255109464701349560000002279926971849666696_",
    cx: 501.5178,
    cy: 387.5895,
    r: 53.2793,
    gradientTransform: "matrix(1.2357 -0.3684 0.2857 0.9583 -488.2797 240.9427)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1038,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3131,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#070707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000000942651463753728830000006201250372589679236_)",
      fill: "url(#SVGID_00000072255109464701349560000002279926971849666696_)"
    },
    d: " M308.02,407.984c8.401,28.197-14.259,59.848-50.618,70.682c-36.365,10.84-72.648-3.232-81.062-31.429 c-8.401-28.198,14.26-59.848,50.618-70.682C263.318,365.715,299.608,379.787,308.02,407.984z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000059988454211882038940000009809302395205879998_",
    filterUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend35 || (_feBlend35 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426,
    id: "SVGID_00000009573771623381484590000001479270877314581125_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000059988454211882038940000009809302395205879998_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000133524411394791007080000018035871321638531740_",
    filterUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend36 || (_feBlend36 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 174.59,
    y: 372.898,
    width: 135.18,
    height: 109.426,
    id: "SVGID_00000009573771623381484590000001479270877314581125_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000133524411394791007080000018035871321638531740_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000134230033806241793690000011293898465181118103_",
    cx: 501.5178,
    cy: 387.5895,
    r: 53.2793,
    gradientTransform: "matrix(1.2357 -0.3684 0.2857 0.9583 -488.2797 240.9427)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1895,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3229,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CDCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9163,
    style: {
      stopColor: "#363636"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000009573771623381484590000001479270877314581125_)",
      fill: "url(#SVGID_00000134230033806241793690000011293898465181118103_)"
    },
    d: " M308.02,407.984c8.401,28.197-14.259,59.848-50.618,70.682c-36.365,10.84-72.648-3.232-81.062-31.429 c-8.401-28.198,14.26-59.848,50.618-70.682C263.318,365.715,299.608,379.787,308.02,407.984z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000039120425463287461050000013175099572042766742_",
    cx: 501.5178,
    cy: 387.5895,
    r: 53.2793,
    gradientTransform: "matrix(1.2357 -0.3684 0.2857 0.9583 -488.2797 240.9427)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    style: {
      stopColor: "#01CEFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#03C5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4975,
    style: {
      stopColor: "#06B6E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#0BA0CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    style: {
      stopColor: "#1284B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8383,
    style: {
      stopColor: "#1A628E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9392,
    style: {
      stopColor: "#233A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A1E49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000039120425463287461050000013175099572042766742_)"
    },
    d: "M308.02,407.984 c8.401,28.197-14.259,59.848-50.618,70.682c-36.365,10.84-72.648-3.232-81.062-31.429c-8.401-28.198,14.26-59.848,50.618-70.682 C263.318,365.715,299.608,379.787,308.02,407.984z"
  })), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000119082749237641663780000012440585111663599806_",
    filterUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635,
    id: "SVGID_00000049180760334056432450000015646790891331832203_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000119082749237641663780000012440585111663599806_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000039132296362266619870000002881074007827993535_",
    filterUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend37 || (_feBlend37 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635,
    id: "SVGID_00000049180760334056432450000015646790891331832203_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000039132296362266619870000002881074007827993535_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000155861378328611014030000011528441489999321228_",
    cx: 564.4118,
    cy: 489.2344,
    r: 40.1775,
    gradientTransform: "matrix(1.6271 -0.1669 0.0924 0.9009 -672.1613 117.8329)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1038,
    style: {
      stopColor: "#EDEDED"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3131,
    style: {
      stopColor: "#BDBDBD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6093,
    style: {
      stopColor: "#707070"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9778,
    style: {
      stopColor: "#070707"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000049180760334056432450000015646790891331832203_)",
      fill: "url(#SVGID_00000155861378328611014030000011528441489999321228_)"
    },
    d: " M356.771,457.68c2.042,19.988-25.56,39.195-61.662,42.9c-36.108,3.699-67.036-9.504-69.083-29.492 c-2.054-19.988,25.554-39.201,61.657-42.9C323.784,424.484,354.718,437.692,356.771,457.68z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000178904085495829689900000014095843757386587796_",
    filterUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend38 || (_feBlend38 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635,
    id: "SVGID_00000144334021772881573640000007556679667393641914_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000178904085495829689900000014095843757386587796_)"
    }
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000037687126229228249370000007721320461392981891_",
    filterUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend39 || (_feBlend39 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 225.918,
    y: 427.566,
    width: 130.96,
    height: 73.635,
    id: "SVGID_00000144334021772881573640000007556679667393641914_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000037687126229228249370000007721320461392981891_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000039819261034997074750000009566759682727859888_",
    cx: 564.4118,
    cy: 489.2344,
    r: 40.1775,
    gradientTransform: "matrix(1.6271 -0.1669 0.0924 0.9009 -672.1613 117.8329)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1895,
    style: {
      stopColor: "#FCFCFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3229,
    style: {
      stopColor: "#F3F3F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4392,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5455,
    style: {
      stopColor: "#CDCDCD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6453,
    style: {
      stopColor: "#B1B1B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#8E8E8E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8309,
    style: {
      stopColor: "#646464"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9163,
    style: {
      stopColor: "#363636"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mask: "url(#SVGID_00000144334021772881573640000007556679667393641914_)",
      fill: "url(#SVGID_00000039819261034997074750000009566759682727859888_)"
    },
    d: " M356.771,457.68c2.042,19.988-25.56,39.195-61.662,42.9c-36.108,3.699-67.036-9.504-69.083-29.492 c-2.054-19.988,25.554-39.201,61.657-42.9C323.784,424.484,354.718,437.692,356.771,457.68z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000096766318114544287110000004956880125140402111_",
    cx: 564.4118,
    cy: 489.2344,
    r: 40.1775,
    gradientTransform: "matrix(1.6271 -0.1669 0.0924 0.9009 -672.1613 117.8329)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00D1FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2147,
    style: {
      stopColor: "#01CEFC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3659,
    style: {
      stopColor: "#03C5F3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4975,
    style: {
      stopColor: "#06B6E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6181,
    style: {
      stopColor: "#0BA0CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731,
    style: {
      stopColor: "#1284B1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8383,
    style: {
      stopColor: "#1A628E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9392,
    style: {
      stopColor: "#233A65"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2A1E49"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.68,
      fill: "url(#SVGID_00000096766318114544287110000004956880125140402111_)"
    },
    d: "M356.771,457.68 c2.042,19.988-25.56,39.195-61.662,42.9c-36.108,3.699-67.036-9.504-69.083-29.492c-2.054-19.988,25.554-39.201,61.657-42.9 C323.784,424.484,354.718,437.692,356.771,457.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M258.604,183.609c0.479,3.652-2.095,7.001-5.747,7.474c-3.653,0.479-6.995-2.095-7.468-5.747 c-0.484-3.641,2.089-6.995,5.741-7.468C254.782,177.396,258.131,179.957,258.604,183.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M253.732,190.885c-0.292,0.07-0.572,0.163-0.875,0.198c-0.187,0.035-0.379,0.017-0.572,0.023 c1.406,29.545,5.928,109.83,7.654,112.386c1.89,2.807,6.78,2.025,7.987,1.774c1.237-0.07,6.161-0.572,7.27-3.769 C276.211,298.585,259.957,219.771,253.732,190.885z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M259.56,241.095c-23.541,3.069-41.884,11.324-40.956,18.413c0.927,7.089,20.764,10.35,44.317,7.275 c23.547-3.069,41.885-11.318,40.957-18.419C302.95,241.276,283.108,238.026,259.56,241.095z M262.064,260.26 c-18.582,2.427-34.154,0.548-34.772-4.189c-0.618-4.743,13.944-10.554,32.532-12.987c18.588-2.421,34.148-0.542,34.772,4.201 C295.214,252.016,280.651,257.839,262.064,260.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M261.602,256.742c-29.772,3.886-52.847,15.163-51.54,25.187 c1.306,10.017,26.511,14.988,56.283,11.102c29.772-3.885,52.853-15.157,51.54-25.181 C316.579,257.822,291.381,252.851,261.602,256.742z M265.138,283.813c-23.495,3.069-43.255,0.129-44.13-6.569 c-0.875-6.698,17.468-14.615,40.968-17.69c23.495-3.063,43.256-0.122,44.131,6.575 C306.981,272.827,288.639,280.75,265.138,283.813z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "#3C4B6D"
    },
    d: "M262.332,262.32c-21.021,2.748-39.072,0.438-43.366-5.128 c-0.327,0.776-0.461,1.552-0.361,2.316c0.927,7.089,20.764,10.35,44.317,7.275c23.547-3.069,41.885-11.318,40.957-18.419 c-0.099-0.753-0.432-1.464-0.951-2.141C300.208,252.717,283.358,259.572,262.332,262.32z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.42
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4B6D"
    },
    d: "M265.605,287.372c-26.914,3.512-50.082-0.216-55.257-8.366c-0.303,0.98-0.414,1.96-0.285,2.923 c1.306,10.017,26.511,14.988,56.283,11.102c29.772-3.885,52.853-15.157,51.54-25.181c-0.122-0.962-0.478-1.878-1.026-2.748 C313.948,274.303,292.518,283.86,265.605,287.372z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.42,
      fill: "#3C4B6D"
    },
    d: "M252.461,188.061c-3.128,0.409-6.016-1.429-7.083-4.259 c-0.046,0.496-0.064,1.016,0.012,1.535c0.473,3.652,3.815,6.225,7.468,5.747c3.652-0.473,6.225-3.822,5.747-7.474 c-0.065-0.519-0.21-1.009-0.385-1.482C257.915,185.132,255.587,187.653,252.461,188.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.52,
      fill: "#3C4B6D"
    },
    d: "M256.9,181.247c0.257,2.019-1.873,3.95-4.761,4.323 c-2.893,0.385-5.449-0.945-5.712-2.946c-0.257-2.019,1.873-3.95,4.761-4.324C254.082,177.915,256.638,179.246,256.9,181.247z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133527112101159230360000012451800492912178091_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.6318,
    y1: 355.8068,
    x2: 240.0833,
    y2: 355.8068
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.58,
      fill: "url(#SVGID_00000133527112101159230360000012451800492912178091_)"
    },
    d: "M204.643,307.768 c-11.931,6.733-22.492,19.627-28.186,28.787c-12.94,20.799-18.985,47.934-11.68,71.785c3.571-3.652,4.335-10.793,7.106-15.542 c5.968-10.239,14.679-19.737,22.788-28.325c11.569-12.27,66.645-39.924,36.505-57.999 C222.49,301.27,213.213,302.926,204.643,307.768z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168838742293866297820000012817006047559693752_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.3547,
    y1: 394.1862,
    x2: 424.4615,
    y2: 394.1862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2768,
    style: {
      stopColor: "#D2E5F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6041,
    style: {
      stopColor: "#A4C9E4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    style: {
      stopColor: "#87B8DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7CB2D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.74,
      fill: "url(#SVGID_00000168838742293866297820000012817006047559693752_)"
    },
    d: "M418.819,408.603 c-1.062-4.382-2.013-8.71-3.361-13.022c-3.448-10.992-8.203-21.517-13.448-31.756c-4.516-8.834-9.218-18.431-15.916-25.869 c0.158,8.955-5.443,29.982-18.74,23.658c25.566,23.302,50.484,53.506,55.851,88.804c2.019-5.122,1.149-13.903,0.502-19.323 c-0.817-6.908-2.66-13.641-4.369-20.373C419.163,410.014,418.994,409.303,418.819,408.603z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.57
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#071F48"
    },
    d: "M411.934,790.509c4.598,5.239,11.009,9.067,17.555,10.659c14.487,3.536,30.011,2.222,44.16-0.467 c25.111-4.755,49.486-12.701,73.74-20.613c15.881-5.175,31.639-10.723,47.619-15.612c15.525-4.755,31.593-6.657,47.211-11.103 c-9.206,2.269-19.101,2.847-28.442,4.819c-10.275,2.177-20.507,4.755-30.677,7.363c-5.881,1.506-11.698,3.261-17.491,5.029 c-6.611,2.013-13.11,3.378-19.726,5.548c-6.995,2.282-14.008,4.504-21.056,6.622c-14.271,4.294-28.669,8.185-43.22,11.4 c-21.015,4.627-45.927,9.563-65.075-3.39c-3.979-2.695-7.007-5.992-10.076-9.439C407.646,784.698,409.542,787.796,411.934,790.509 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.1744251203ba91862d60613079fce58b.svg";
export { ForwardRef as ReactComponent };